function PlanCC({ ...props }) {
	return (
		<g {...props} id="unit-cc">
			<g id="furniture">
				<polyline
					points="829.95 462.24 824.19 462.24 824.19 459.33 829.95 459.33 829.95 462.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="901.83 208.57 901.83 456.41 839.35 456.41 839.35 208.57 901.83 208.57"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="378.6 724.7 455.59 724.7 455.59 685.65 378.6 685.65 378.6 724.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="378.6"
					y1="685.65"
					x2="378.6"
					y2="724.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="685.65"
					x2="378.6"
					y2="685.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="724.7"
					x2="455.59"
					y2="685.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.6"
					y1="724.7"
					x2="455.59"
					y2="724.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.6"
					y1="724.7"
					x2="380.53"
					y2="724.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.98"
					y1="724.7"
					x2="390.23"
					y2="724.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.98"
					y1="724.7"
					x2="400.23"
					y2="724.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.98"
					y1="724.7"
					x2="410.22"
					y2="724.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.97"
					y1="724.7"
					x2="420.22"
					y2="724.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.97"
					y1="724.7"
					x2="430.22"
					y2="724.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.96"
					y1="724.7"
					x2="440.21"
					y2="724.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.96"
					y1="724.7"
					x2="450.21"
					y2="724.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.66"
					y1="724.7"
					x2="455.59"
					y2="724.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="724.7"
					x2="455.59"
					y2="718.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="714.6"
					x2="455.59"
					y2="708.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="704.6"
					x2="455.59"
					y2="698.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="694.61"
					x2="455.59"
					y2="688.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="688.25"
					x2="453.66"
					y2="688.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.21"
					y1="688.25"
					x2="443.96"
					y2="688.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.21"
					y1="688.25"
					x2="433.96"
					y2="688.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.22"
					y1="688.25"
					x2="423.97"
					y2="688.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="420.22"
					y1="688.25"
					x2="413.97"
					y2="688.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.22"
					y1="688.25"
					x2="403.98"
					y2="688.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.23"
					y1="688.25"
					x2="393.98"
					y2="688.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.23"
					y1="688.25"
					x2="383.98"
					y2="688.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.53"
					y1="688.25"
					x2="378.6"
					y2="688.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.6"
					y1="688.25"
					x2="378.6"
					y2="694.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.6"
					y1="698.35"
					x2="378.6"
					y2="704.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.6"
					y1="708.35"
					x2="378.6"
					y2="714.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.6"
					y1="718.35"
					x2="378.6"
					y2="724.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="109.87"
					y1="612.54"
					x2="109.87"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.21"
					y1="612.54"
					x2="109.87"
					y2="612.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="97.41"
					y1="651.59"
					x2="103.66"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.21"
					y1="631.49"
					x2="220.21"
					y2="625.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.21"
					y1="621.49"
					x2="220.21"
					y2="615.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.21"
					y1="615.14"
					x2="215.6"
					y2="615.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.85"
					y1="615.14"
					x2="205.6"
					y2="615.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.85"
					y1="615.14"
					x2="195.6"
					y2="615.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.85"
					y1="615.14"
					x2="185.61"
					y2="615.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.86"
					y1="615.14"
					x2="175.61"
					y2="615.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171.86"
					y1="615.14"
					x2="165.61"
					y2="615.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.87"
					y1="615.14"
					x2="155.62"
					y2="615.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="151.87"
					y1="615.14"
					x2="145.62"
					y2="615.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="141.87"
					y1="615.14"
					x2="135.62"
					y2="615.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.88"
					y1="615.14"
					x2="125.63"
					y2="615.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="121.88"
					y1="615.14"
					x2="115.63"
					y2="615.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.88"
					y1="615.14"
					x2="107.27"
					y2="615.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.27"
					y1="615.14"
					x2="107.27"
					y2="613.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.27"
					y1="609.53"
					x2="107.27"
					y2="603.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.27"
					y1="599.53"
					x2="107.27"
					y2="593.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.27"
					y1="589.53"
					x2="107.27"
					y2="583.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.27"
					y1="579.53"
					x2="107.27"
					y2="573.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.27"
					y1="569.54"
					x2="107.27"
					y2="563.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.27"
					y1="559.54"
					x2="107.27"
					y2="553.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.27"
					y1="549.55"
					x2="107.27"
					y2="543.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.27"
					y1="539.55"
					x2="107.27"
					y2="533.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.27"
					y1="529.55"
					x2="107.27"
					y2="523.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.27"
					y1="519.56"
					x2="107.27"
					y2="513.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.27"
					y1="509.56"
					x2="107.27"
					y2="503.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.27"
					y1="499.63"
					x2="107.27"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.27"
					y1="497.7"
					x2="100.92"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="97.17"
					y1="497.7"
					x2="90.92"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="450.41 841.04 386.09 841.04 386.09 776.72 450.41 776.72 450.41 841.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="202.37 116.48 202.37 119.08 97.46 119.08 97.46 116.48 202.37 116.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="202.37"
					y1="116.48"
					x2="202.37"
					y2="119.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.37"
					y1="119.08"
					x2="97.46"
					y2="119.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="97.46"
					y1="119.08"
					x2="97.46"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="97.46"
					y1="116.48"
					x2="202.37"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="255.62 115.45 211.63 115.45 211.63 121.09 255.62 121.09 255.62 115.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="209.58 114.94 257.67 114.94 257.67 115.45 209.58 115.45 209.58 114.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="209.58"
					y1="114.94"
					x2="257.67"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.67"
					y1="114.94"
					x2="257.67"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.67"
					y1="115.45"
					x2="209.58"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.58"
					y1="115.45"
					x2="209.58"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.62"
					y1="121.09"
					x2="211.63"
					y2="121.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.63"
					y1="115.45"
					x2="255.62"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="260.23 121.09 255.62 121.09 255.62 115.45 260.23 115.45 260.23 121.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="260.23"
					y1="121.09"
					x2="255.62"
					y2="121.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.62"
					y1="121.09"
					x2="255.62"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.62"
					y1="115.45"
					x2="260.23"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.23"
					y1="115.45"
					x2="260.23"
					y2="121.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="207.02 115.45 211.63 115.45 211.63 121.09 207.02 121.09 207.02 115.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="207.02"
					y1="115.45"
					x2="211.63"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.63"
					y1="115.45"
					x2="211.63"
					y2="121.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.63"
					y1="121.09"
					x2="207.02"
					y2="121.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.02"
					y1="121.09"
					x2="207.02"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.62"
					y1="116.48"
					x2="211.63"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="262.28 120.58 260.23 120.58 260.23 115.45 257.67 115.45 257.67 114.94 262.28 114.94 262.28 120.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="262.28"
					y1="120.58"
					x2="260.23"
					y2="120.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.23"
					y1="120.58"
					x2="260.23"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.23"
					y1="115.45"
					x2="257.67"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.67"
					y1="115.45"
					x2="257.67"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.67"
					y1="114.94"
					x2="262.28"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.28"
					y1="114.94"
					x2="262.28"
					y2="120.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="204.97 114.94 209.58 114.94 209.58 115.45 207.02 115.45 207.02 120.58 204.97 120.58 204.97 114.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="204.97"
					y1="114.94"
					x2="209.58"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.58"
					y1="114.94"
					x2="209.58"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.58"
					y1="115.45"
					x2="207.02"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.02"
					y1="115.45"
					x2="207.02"
					y2="120.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.02"
					y1="120.58"
					x2="204.97"
					y2="120.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.97"
					y1="120.58"
					x2="204.97"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="94.85 116.48 100.06 116.48 100.06 132.1 94.85 132.1 94.85 116.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="100.06"
					y1="116.48"
					x2="94.85"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="100.06"
					y1="132.1"
					x2="100.06"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.85"
					y1="132.1"
					x2="100.06"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.85"
					y1="116.48"
					x2="94.85"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="199.76 116.48 204.97 116.48 204.97 132.1 199.76 132.1 199.76 116.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="204.97"
					y1="116.48"
					x2="199.76"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.97"
					y1="132.1"
					x2="204.97"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.76"
					y1="132.1"
					x2="204.97"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.76"
					y1="116.48"
					x2="199.76"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="267.49 116.48 267.49 132.1 262.28 132.1 262.28 116.48 267.49 116.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="267.49"
					y1="132.1"
					x2="267.49"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.28"
					y1="132.1"
					x2="267.49"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.28"
					y1="116.48"
					x2="262.28"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.49"
					y1="116.48"
					x2="262.28"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="501.74 116.48 501.74 119.08 410.4 119.08 410.4 116.48 501.74 116.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="501.74"
					y1="116.48"
					x2="501.74"
					y2="119.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.74"
					y1="119.08"
					x2="410.4"
					y2="119.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.4"
					y1="119.08"
					x2="410.4"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.4"
					y1="116.48"
					x2="501.74"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="553.2 115.45 511 115.45 511 121.09 553.2 121.09 553.2 115.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="508.95 114.94 555.25 114.94 555.25 115.45 508.95 115.45 508.95 114.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="508.95"
					y1="114.94"
					x2="555.25"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.25"
					y1="114.94"
					x2="555.25"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.25"
					y1="115.45"
					x2="508.95"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.95"
					y1="115.45"
					x2="508.95"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.2"
					y1="121.09"
					x2="511"
					y2="121.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511"
					y1="115.45"
					x2="553.2"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="557.81 121.09 553.2 121.09 553.2 115.45 557.81 115.45 557.81 121.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="557.81"
					y1="121.09"
					x2="553.2"
					y2="121.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.2"
					y1="121.09"
					x2="553.2"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.2"
					y1="115.45"
					x2="557.81"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.81"
					y1="115.45"
					x2="557.81"
					y2="121.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="506.39 115.45 511 115.45 511 121.09 506.39 121.09 506.39 115.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="506.39"
					y1="115.45"
					x2="511"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511"
					y1="115.45"
					x2="511"
					y2="121.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511"
					y1="121.09"
					x2="506.39"
					y2="121.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.39"
					y1="121.09"
					x2="506.39"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.2"
					y1="116.48"
					x2="511"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="559.86 120.58 557.81 120.58 557.81 115.45 555.25 115.45 555.25 114.94 559.86 114.94 559.86 120.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="559.86"
					y1="120.58"
					x2="557.81"
					y2="120.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.81"
					y1="120.58"
					x2="557.81"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.81"
					y1="115.45"
					x2="555.25"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.25"
					y1="115.45"
					x2="555.25"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.25"
					y1="114.94"
					x2="559.86"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.86"
					y1="114.94"
					x2="559.86"
					y2="120.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="504.34 114.94 508.95 114.94 508.95 115.45 506.39 115.45 506.39 120.58 504.34 120.58 504.34 114.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="504.34"
					y1="114.94"
					x2="508.95"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.95"
					y1="114.94"
					x2="508.95"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.95"
					y1="115.45"
					x2="506.39"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.39"
					y1="115.45"
					x2="506.39"
					y2="120.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.39"
					y1="120.58"
					x2="504.34"
					y2="120.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.34"
					y1="120.58"
					x2="504.34"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="565.07 116.48 565.07 132.1 559.86 132.1 559.86 116.48 565.07 116.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="565.07"
					y1="132.1"
					x2="565.07"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.86"
					y1="132.1"
					x2="565.07"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.86"
					y1="116.48"
					x2="559.86"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.07"
					y1="116.48"
					x2="559.86"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="499.14 116.48 504.34 116.48 504.34 132.1 499.14 132.1 499.14 116.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="504.34"
					y1="116.48"
					x2="499.14"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.34"
					y1="132.1"
					x2="504.34"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.14"
					y1="132.1"
					x2="504.34"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.14"
					y1="116.48"
					x2="499.14"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="407.8 116.48 413 116.48 413 132.1 407.8 132.1 407.8 116.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="413"
					y1="116.48"
					x2="407.8"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413"
					y1="132.1"
					x2="413"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.8"
					y1="132.1"
					x2="413"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.8"
					y1="116.48"
					x2="407.8"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="782.07 116.48 782.07 119.08 676.57 119.08 676.57 116.48 782.07 116.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="782.07"
					y1="116.48"
					x2="782.07"
					y2="119.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.07"
					y1="119.08"
					x2="676.57"
					y2="119.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.57"
					y1="119.08"
					x2="676.57"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="676.57"
					y1="116.48"
					x2="782.07"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="835 115.45 791.34 115.45 791.34 121.09 835 121.09 835 115.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="789.29 114.94 837.05 114.94 837.05 115.45 789.29 115.45 789.29 114.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="789.29"
					y1="114.94"
					x2="837.05"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.05"
					y1="114.94"
					x2="837.05"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.05"
					y1="115.45"
					x2="789.29"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.29"
					y1="115.45"
					x2="789.29"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835"
					y1="121.09"
					x2="791.34"
					y2="121.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.34"
					y1="115.45"
					x2="835"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="839.61 121.09 835 121.09 835 115.45 839.61 115.45 839.61 121.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="839.61"
					y1="121.09"
					x2="835"
					y2="121.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835"
					y1="121.09"
					x2="835"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835"
					y1="115.45"
					x2="839.61"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.61"
					y1="115.45"
					x2="839.61"
					y2="121.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="786.73 115.45 791.34 115.45 791.34 121.09 786.73 121.09 786.73 115.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="786.73"
					y1="115.45"
					x2="791.34"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.34"
					y1="115.45"
					x2="791.34"
					y2="121.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.34"
					y1="121.09"
					x2="786.73"
					y2="121.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.73"
					y1="121.09"
					x2="786.73"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835"
					y1="116.48"
					x2="791.34"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="841.66 120.58 839.61 120.58 839.61 115.45 837.05 115.45 837.05 114.94 841.66 114.94 841.66 120.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="841.66"
					y1="120.58"
					x2="839.61"
					y2="120.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.61"
					y1="120.58"
					x2="839.61"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.61"
					y1="115.45"
					x2="837.05"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.05"
					y1="115.45"
					x2="837.05"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.05"
					y1="114.94"
					x2="841.66"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.66"
					y1="114.94"
					x2="841.66"
					y2="120.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="784.68 114.94 789.29 114.94 789.29 115.45 786.73 115.45 786.73 120.58 784.68 120.58 784.68 114.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="784.68"
					y1="114.94"
					x2="789.29"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.29"
					y1="114.94"
					x2="789.29"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.29"
					y1="115.45"
					x2="786.73"
					y2="115.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.73"
					y1="115.45"
					x2="786.73"
					y2="120.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.73"
					y1="120.58"
					x2="784.68"
					y2="120.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.68"
					y1="120.58"
					x2="784.68"
					y2="114.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="779.47 116.48 784.68 116.48 784.68 132.1 779.47 132.1 779.47 116.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="784.68"
					y1="116.48"
					x2="779.47"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.68"
					y1="132.1"
					x2="784.68"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.47"
					y1="132.1"
					x2="784.68"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.47"
					y1="116.48"
					x2="779.47"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="846.87 116.48 846.87 132.1 841.66 132.1 841.66 116.48 846.87 116.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="846.87"
					y1="132.1"
					x2="846.87"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.66"
					y1="132.1"
					x2="846.87"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.66"
					y1="116.48"
					x2="841.66"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.87"
					y1="116.48"
					x2="841.66"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="673.97 116.48 679.18 116.48 679.18 132.1 673.97 132.1 673.97 116.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="679.18"
					y1="116.48"
					x2="673.97"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.18"
					y1="132.1"
					x2="679.18"
					y2="116.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.97"
					y1="132.1"
					x2="679.18"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.97"
					y1="116.48"
					x2="673.97"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="929.18"
					y1="456.41"
					x2="929.18"
					y2="543.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="901.83"
					y1="456.41"
					x2="929.18"
					y2="456.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="901.83"
					y1="456.41"
					x2="901.83"
					y2="435.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="901.83"
					y1="208.57"
					x2="901.83"
					y2="435.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="874.55"
					y1="208.57"
					x2="901.83"
					y2="208.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="846.87"
					y1="111.27"
					x2="846.87"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="125.34"
					y1="664.6"
					x2="125.34"
					y2="672.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="125.34"
					y1="819.42"
					x2="125.34"
					y2="672.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="378.6"
					y1="846.51"
					x2="378.6"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="504.74"
					y1="846.51"
					x2="468.61"
					y2="846.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="455.59"
					y1="846.51"
					x2="378.6"
					y2="846.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="650.35"
					y1="887.43"
					x2="654.26"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="650.35"
					y1="866.6"
					x2="654.26"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="650.35"
					y1="866.6"
					x2="650.35"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="551.43"
					y1="887.43"
					x2="547.53"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="551.43"
					y1="866.6"
					x2="547.53"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="551.43"
					y1="866.6"
					x2="551.43"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="650.35"
					y1="887.43"
					x2="659.31"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="659.31"
					y1="866.6"
					x2="650.35"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<polyline
					points="552.73 888.73 552.73 887.43 547.53 887.43 547.53 888.73 552.73 888.73"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="649.05 887.43 649.05 888.73 654.26 888.73 654.26 887.43 649.05 887.43"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="552.73 866.6 552.73 865.3 547.53 865.3 547.53 866.6 552.73 866.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="649.05 865.3 649.05 866.6 654.26 866.6 654.26 865.3 649.05 865.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="552.73"
					y1="888.73"
					x2="547.53"
					y2="888.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.53"
					y1="888.73"
					x2="547.53"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.53"
					y1="887.43"
					x2="552.73"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.73"
					y1="887.43"
					x2="552.73"
					y2="888.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.05"
					y1="887.43"
					x2="654.26"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.26"
					y1="887.43"
					x2="654.26"
					y2="888.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.26"
					y1="888.73"
					x2="649.05"
					y2="888.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.05"
					y1="888.73"
					x2="649.05"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.73"
					y1="866.6"
					x2="547.53"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.53"
					y1="866.6"
					x2="547.53"
					y2="865.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.53"
					y1="865.3"
					x2="552.73"
					y2="865.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.73"
					y1="865.3"
					x2="552.73"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.05"
					y1="865.3"
					x2="654.26"
					y2="865.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.26"
					y1="865.3"
					x2="654.26"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.26"
					y1="866.6"
					x2="649.05"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.05"
					y1="866.6"
					x2="649.05"
					y2="865.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="554.03 887.43 554.03 866.6 552.08 866.6 552.08 887.43 554.03 887.43"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="649.7 887.43 649.7 866.6 647.75 866.6 647.75 887.43 649.7 887.43"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="581.48 800.34 578.26 803.56 644.53 869.83 647.75 866.6 581.48 800.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="552.08"
					y1="866.6"
					x2="551.43"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.08"
					y1="887.43"
					x2="551.43"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.43"
					y1="866.6"
					x2="551.43"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.7"
					y1="866.6"
					x2="650.35"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.7"
					y1="887.43"
					x2="650.35"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.35"
					y1="866.6"
					x2="650.35"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.03"
					y1="887.43"
					x2="554.03"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.03"
					y1="866.6"
					x2="552.08"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.08"
					y1="866.6"
					x2="552.08"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.08"
					y1="887.43"
					x2="554.03"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.7"
					y1="887.43"
					x2="649.7"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.7"
					y1="866.6"
					x2="647.75"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.75"
					y1="866.6"
					x2="647.75"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.75"
					y1="887.43"
					x2="649.7"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="581.48"
					y1="800.34"
					x2="578.26"
					y2="803.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.26"
					y1="803.56"
					x2="644.53"
					y2="869.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.53"
					y1="869.83"
					x2="647.75"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.75"
					y1="866.6"
					x2="581.48"
					y2="800.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.43"
					y1="866.6"
					x2="551.43"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="551.43"
					y1="866.6"
					x2="551.43"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="551.43"
					y1="866.6"
					x2="547.53"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="551.43"
					y1="866.6"
					x2="547.53"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="551.43"
					y1="887.43"
					x2="547.53"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="551.43"
					y1="887.43"
					x2="547.53"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="650.35"
					y1="866.6"
					x2="650.35"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="650.35"
					y1="866.6"
					x2="650.35"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="650.35"
					y1="866.6"
					x2="654.26"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="650.35"
					y1="866.6"
					x2="654.26"
					y2="866.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="650.35"
					y1="887.43"
					x2="654.26"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="650.35"
					y1="887.43"
					x2="654.26"
					y2="887.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="360.39"
					y1="651.59"
					x2="364.29"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="360.39"
					y1="664.6"
					x2="364.29"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="360.39"
					y1="664.6"
					x2="360.39"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="261.46"
					y1="651.59"
					x2="257.56"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="261.46"
					y1="664.6"
					x2="257.56"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="261.46"
					y1="664.6"
					x2="261.46"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="449.89"
					y1="664.6"
					x2="453.79"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="449.89"
					y1="651.59"
					x2="453.79"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="449.89"
					y1="651.59"
					x2="449.89"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="387.41"
					y1="664.6"
					x2="383.51"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="387.41"
					y1="651.59"
					x2="383.51"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="387.41"
					y1="651.59"
					x2="387.41"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="125.34"
					y1="664.6"
					x2="261.46"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="449.89"
					y1="664.6"
					x2="455.59"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<polyline
					points="262.76 650.29 257.56 650.29 257.56 651.59 262.76 651.59 262.76 650.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="359.09 651.59 364.29 651.59 364.29 650.29 359.09 650.29 359.09 651.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="262.76 664.6 257.56 664.6 257.56 665.91 262.76 665.91 262.76 664.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="359.09 665.91 364.29 665.91 364.29 664.6 359.09 664.6 359.09 665.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="262.76"
					y1="650.29"
					x2="257.56"
					y2="650.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.56"
					y1="650.29"
					x2="257.56"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.56"
					y1="651.59"
					x2="262.76"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.76"
					y1="651.59"
					x2="262.76"
					y2="650.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.09"
					y1="651.59"
					x2="364.29"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.29"
					y1="651.59"
					x2="364.29"
					y2="650.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.29"
					y1="650.29"
					x2="359.09"
					y2="650.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.09"
					y1="650.29"
					x2="359.09"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.76"
					y1="664.6"
					x2="257.56"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.56"
					y1="664.6"
					x2="257.56"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.56"
					y1="665.91"
					x2="262.76"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.76"
					y1="665.91"
					x2="262.76"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.09"
					y1="665.91"
					x2="364.29"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.29"
					y1="665.91"
					x2="364.29"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.29"
					y1="664.6"
					x2="359.09"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.09"
					y1="664.6"
					x2="359.09"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="264.07 651.59 262.11 651.59 262.11 664.6 264.07 664.6 264.07 651.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="359.74 651.59 357.79 651.59 357.79 664.6 359.74 664.6 359.74 651.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="291.52 730.87 357.79 664.6 354.56 661.38 288.29 727.65 291.52 730.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="262.11"
					y1="664.6"
					x2="261.46"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.11"
					y1="651.59"
					x2="261.46"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.46"
					y1="664.6"
					x2="261.46"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.74"
					y1="664.6"
					x2="360.39"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.74"
					y1="651.59"
					x2="360.39"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.39"
					y1="664.6"
					x2="360.39"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.07"
					y1="651.59"
					x2="264.07"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.07"
					y1="664.6"
					x2="262.11"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.11"
					y1="664.6"
					x2="262.11"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.11"
					y1="651.59"
					x2="264.07"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.74"
					y1="651.59"
					x2="359.74"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.74"
					y1="664.6"
					x2="357.79"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.79"
					y1="664.6"
					x2="357.79"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.79"
					y1="651.59"
					x2="359.74"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.52"
					y1="730.87"
					x2="288.29"
					y2="727.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.29"
					y1="727.65"
					x2="354.56"
					y2="661.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.56"
					y1="661.38"
					x2="357.79"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.79"
					y1="664.6"
					x2="291.52"
					y2="730.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.46"
					y1="664.6"
					x2="261.46"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="261.46"
					y1="664.6"
					x2="261.46"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="261.46"
					y1="664.6"
					x2="257.56"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="261.46"
					y1="664.6"
					x2="257.56"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="261.46"
					y1="651.59"
					x2="257.56"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="261.46"
					y1="651.59"
					x2="257.56"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="360.39"
					y1="664.6"
					x2="360.39"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="360.39"
					y1="664.6"
					x2="360.39"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="360.39"
					y1="664.6"
					x2="364.29"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="360.39"
					y1="664.6"
					x2="364.29"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="360.39"
					y1="651.59"
					x2="364.29"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="360.39"
					y1="651.59"
					x2="364.29"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<polyline
					points="388.71 665.91 388.71 664.6 383.51 664.6 383.51 665.91 388.71 665.91"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="448.59 664.6 448.59 665.91 453.79 665.91 453.79 664.6 448.59 664.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="388.71 651.59 388.71 650.29 383.51 650.29 383.51 651.59 388.71 651.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="448.59 650.29 448.59 651.59 453.79 651.59 453.79 650.29 448.59 650.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="388.71"
					y1="665.91"
					x2="383.51"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.51"
					y1="665.91"
					x2="383.51"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.51"
					y1="664.6"
					x2="388.71"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.71"
					y1="664.6"
					x2="388.71"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.59"
					y1="664.6"
					x2="453.79"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.79"
					y1="664.6"
					x2="453.79"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.79"
					y1="665.91"
					x2="448.59"
					y2="665.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.59"
					y1="665.91"
					x2="448.59"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.71"
					y1="651.59"
					x2="383.51"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.51"
					y1="651.59"
					x2="383.51"
					y2="650.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.51"
					y1="650.29"
					x2="388.71"
					y2="650.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.71"
					y1="650.29"
					x2="388.71"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.59"
					y1="650.29"
					x2="453.79"
					y2="650.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.79"
					y1="650.29"
					x2="453.79"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.79"
					y1="651.59"
					x2="448.59"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.59"
					y1="651.59"
					x2="448.59"
					y2="650.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="390.02 664.6 390.02 651.59 388.06 651.59 388.06 664.6 390.02 664.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="449.24 664.6 449.24 651.59 447.29 651.59 447.29 664.6 449.24 664.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="406.79 611.09 403.57 614.31 444.06 654.81 447.29 651.59 406.79 611.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="388.06"
					y1="651.59"
					x2="387.41"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.06"
					y1="664.6"
					x2="387.41"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.41"
					y1="651.59"
					x2="387.41"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.24"
					y1="651.59"
					x2="449.89"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.24"
					y1="664.6"
					x2="449.89"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.89"
					y1="651.59"
					x2="449.89"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.02"
					y1="664.6"
					x2="390.02"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.02"
					y1="651.59"
					x2="388.06"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.06"
					y1="651.59"
					x2="388.06"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.06"
					y1="664.6"
					x2="390.02"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.24"
					y1="664.6"
					x2="449.24"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.24"
					y1="651.59"
					x2="447.29"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.29"
					y1="651.59"
					x2="447.29"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.29"
					y1="664.6"
					x2="449.24"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.79"
					y1="611.09"
					x2="403.57"
					y2="614.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.57"
					y1="614.31"
					x2="444.06"
					y2="654.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.06"
					y1="654.81"
					x2="447.29"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.29"
					y1="651.59"
					x2="406.79"
					y2="611.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.41"
					y1="651.59"
					x2="387.41"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="387.41"
					y1="651.59"
					x2="387.41"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="387.41"
					y1="651.59"
					x2="383.51"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="387.41"
					y1="651.59"
					x2="383.51"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="387.41"
					y1="664.6"
					x2="383.51"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="387.41"
					y1="664.6"
					x2="383.51"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="449.89"
					y1="651.59"
					x2="449.89"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="449.89"
					y1="651.59"
					x2="449.89"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="449.89"
					y1="651.59"
					x2="453.79"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="449.89"
					y1="651.59"
					x2="453.79"
					y2="651.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="449.89"
					y1="664.6"
					x2="453.79"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="449.89"
					y1="664.6"
					x2="453.79"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="455.59"
					y1="842.18"
					x2="455.59"
					y2="846.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.61"
					y1="842.18"
					x2="468.61"
					y2="846.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.61"
					y1="842.18"
					x2="455.59"
					y2="842.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="455.59"
					y1="774.49"
					x2="455.59"
					y2="770.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.61"
					y1="774.49"
					x2="468.61"
					y2="770.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.61"
					y1="774.49"
					x2="455.59"
					y2="774.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="455.59"
					y1="664.6"
					x2="455.59"
					y2="724.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="455.59"
					y1="770.16"
					x2="455.59"
					y2="774.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="455.59"
					y1="842.18"
					x2="455.59"
					y2="846.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.61"
					y1="846.51"
					x2="468.61"
					y2="842.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<polyline
					points="454.29 775.79 455.59 775.79 455.59 770.59 454.29 770.59 454.29 775.79"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="455.59 840.87 454.29 840.87 454.29 846.08 455.59 846.08 455.59 840.87"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="468.61 775.79 469.91 775.79 469.91 770.59 468.61 770.59 468.61 775.79"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="469.91 840.87 468.61 840.87 468.61 846.08 469.91 846.08 469.91 840.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="454.29"
					y1="775.79"
					x2="454.29"
					y2="770.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.29"
					y1="770.59"
					x2="455.59"
					y2="770.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="770.59"
					x2="455.59"
					y2="775.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="775.79"
					x2="454.29"
					y2="775.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="840.87"
					x2="455.59"
					y2="846.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="846.08"
					x2="454.29"
					y2="846.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.29"
					y1="846.08"
					x2="454.29"
					y2="840.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.29"
					y1="840.87"
					x2="455.59"
					y2="840.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.61"
					y1="775.79"
					x2="468.61"
					y2="770.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.61"
					y1="770.59"
					x2="469.91"
					y2="770.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.91"
					y1="770.59"
					x2="469.91"
					y2="775.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.91"
					y1="775.79"
					x2="468.61"
					y2="775.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.91"
					y1="840.87"
					x2="469.91"
					y2="846.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.91"
					y1="846.08"
					x2="468.61"
					y2="846.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.61"
					y1="846.08"
					x2="468.61"
					y2="840.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.61"
					y1="840.87"
					x2="469.91"
					y2="840.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="455.59 777.09 468.61 777.09 468.61 775.14 455.59 775.14 455.59 777.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="455.59 841.52 468.61 841.52 468.61 839.57 455.59 839.57 455.59 841.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="512.79 795.39 509.57 792.17 465.39 836.35 468.61 839.57 512.79 795.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="468.61"
					y1="775.14"
					x2="468.61"
					y2="774.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="775.14"
					x2="455.59"
					y2="774.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.61"
					y1="774.49"
					x2="455.59"
					y2="774.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.61"
					y1="841.52"
					x2="468.61"
					y2="842.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="841.52"
					x2="455.59"
					y2="842.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.61"
					y1="842.18"
					x2="455.59"
					y2="842.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="777.09"
					x2="468.61"
					y2="777.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.61"
					y1="777.09"
					x2="468.61"
					y2="775.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.61"
					y1="775.14"
					x2="455.59"
					y2="775.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="775.14"
					x2="455.59"
					y2="777.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="841.52"
					x2="468.61"
					y2="841.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.61"
					y1="841.52"
					x2="468.61"
					y2="839.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.61"
					y1="839.57"
					x2="455.59"
					y2="839.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.59"
					y1="839.57"
					x2="455.59"
					y2="841.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.79"
					y1="795.39"
					x2="509.57"
					y2="792.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.57"
					y1="792.17"
					x2="465.39"
					y2="836.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.39"
					y1="836.35"
					x2="468.61"
					y2="839.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.61"
					y1="839.57"
					x2="512.79"
					y2="795.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.61"
					y1="774.49"
					x2="455.59"
					y2="774.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.61"
					y1="774.49"
					x2="455.59"
					y2="774.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.61"
					y1="774.49"
					x2="468.61"
					y2="770.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.61"
					y1="774.49"
					x2="468.61"
					y2="770.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="455.59"
					y1="774.49"
					x2="455.59"
					y2="770.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="455.59"
					y1="774.49"
					x2="455.59"
					y2="770.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.61"
					y1="842.18"
					x2="455.59"
					y2="842.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.61"
					y1="842.18"
					x2="455.59"
					y2="842.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.61"
					y1="842.18"
					x2="468.61"
					y2="846.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="468.61"
					y1="842.18"
					x2="468.61"
					y2="846.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="455.59"
					y1="842.18"
					x2="455.59"
					y2="846.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="455.59"
					y1="842.18"
					x2="455.59"
					y2="846.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="378.6"
					y1="839.21"
					x2="378.6"
					y2="770.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="378.6"
					y1="724.7"
					x2="378.6"
					y2="664.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="365.58"
					y1="664.62"
					x2="365.58"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="378.6"
					y1="770.16"
					x2="455.59"
					y2="770.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="455.59"
					y1="724.7"
					x2="378.6"
					y2="724.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="205.28"
					y1="819.42"
					x2="192.26"
					y2="819.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="192.26"
					y1="819.42"
					x2="125.34"
					y2="819.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.06"
					y1="484.68"
					x2="216.96"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.06"
					y1="497.7"
					x2="216.96"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.06"
					y1="497.7"
					x2="213.06"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="114.13"
					y1="484.68"
					x2="110.23"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="114.13"
					y1="497.7"
					x2="110.23"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="114.13"
					y1="497.7"
					x2="114.13"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="220.21"
					y1="484.68"
					x2="213.06"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.06"
					y1="497.7"
					x2="220.21"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<polyline
					points="115.43 483.38 110.23 483.38 110.23 484.68 115.43 484.68 115.43 483.38"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="211.76 484.68 216.96 484.68 216.96 483.38 211.76 483.38 211.76 484.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="115.43 497.7 110.23 497.7 110.23 499 115.43 499 115.43 497.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="211.76 499 216.96 499 216.96 497.7 211.76 497.7 211.76 499"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="115.43"
					y1="483.38"
					x2="110.23"
					y2="483.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.23"
					y1="483.38"
					x2="110.23"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.23"
					y1="484.68"
					x2="115.43"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="115.43"
					y1="484.68"
					x2="115.43"
					y2="483.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.76"
					y1="484.68"
					x2="216.96"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.96"
					y1="484.68"
					x2="216.96"
					y2="483.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.96"
					y1="483.38"
					x2="211.76"
					y2="483.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.76"
					y1="483.38"
					x2="211.76"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="115.43"
					y1="497.7"
					x2="110.23"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.23"
					y1="497.7"
					x2="110.23"
					y2="499"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.23"
					y1="499"
					x2="115.43"
					y2="499"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="115.43"
					y1="499"
					x2="115.43"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.76"
					y1="499"
					x2="216.96"
					y2="499"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.96"
					y1="499"
					x2="216.96"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.96"
					y1="497.7"
					x2="211.76"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.76"
					y1="497.7"
					x2="211.76"
					y2="499"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="116.74 484.68 114.78 484.68 114.78 497.7 116.74 497.7 116.74 484.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="212.41 484.68 210.45 484.68 210.45 497.7 212.41 497.7 212.41 484.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="144.19 563.96 210.45 497.7 207.23 494.47 140.96 560.74 144.19 563.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="114.78"
					y1="497.7"
					x2="114.13"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="114.78"
					y1="484.68"
					x2="114.13"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="114.13"
					y1="497.7"
					x2="114.13"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.41"
					y1="497.7"
					x2="213.06"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.41"
					y1="484.68"
					x2="213.06"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.06"
					y1="497.7"
					x2="213.06"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.74"
					y1="484.68"
					x2="116.74"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.74"
					y1="497.7"
					x2="114.78"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="114.78"
					y1="497.7"
					x2="114.78"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="114.78"
					y1="484.68"
					x2="116.74"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.41"
					y1="484.68"
					x2="212.41"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.41"
					y1="497.7"
					x2="210.45"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.45"
					y1="497.7"
					x2="210.45"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.45"
					y1="484.68"
					x2="212.41"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.19"
					y1="563.96"
					x2="140.96"
					y2="560.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="140.96"
					y1="560.74"
					x2="207.23"
					y2="494.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.23"
					y1="494.47"
					x2="210.45"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.45"
					y1="497.7"
					x2="144.19"
					y2="563.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="114.13"
					y1="497.7"
					x2="114.13"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="114.13"
					y1="497.7"
					x2="114.13"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="114.13"
					y1="497.7"
					x2="110.23"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="114.13"
					y1="497.7"
					x2="110.23"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="114.13"
					y1="484.68"
					x2="110.23"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="114.13"
					y1="484.68"
					x2="110.23"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.06"
					y1="497.7"
					x2="213.06"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.06"
					y1="497.7"
					x2="213.06"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.06"
					y1="497.7"
					x2="216.96"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.06"
					y1="497.7"
					x2="216.96"
					y2="497.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.06"
					y1="484.68"
					x2="216.96"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="213.06"
					y1="484.68"
					x2="216.96"
					y2="484.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="372.26"
					y1="529.47"
					x2="376.17"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="372.26"
					y1="516.45"
					x2="376.17"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="372.26"
					y1="516.45"
					x2="372.26"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="273.34"
					y1="529.47"
					x2="269.43"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="273.34"
					y1="516.45"
					x2="269.43"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="273.34"
					y1="516.45"
					x2="273.34"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<polyline
					points="274.64 530.77 274.64 529.47 269.43 529.47 269.43 530.77 274.64 530.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="370.96 529.47 370.96 530.77 376.17 530.77 376.17 529.47 370.96 529.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="274.64 516.45 274.64 515.15 269.43 515.15 269.43 516.45 274.64 516.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="370.96 515.15 370.96 516.45 376.17 516.45 376.17 515.15 370.96 515.15"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="274.64"
					y1="530.77"
					x2="269.43"
					y2="530.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.43"
					y1="530.77"
					x2="269.43"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.43"
					y1="529.47"
					x2="274.64"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.64"
					y1="529.47"
					x2="274.64"
					y2="530.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.96"
					y1="529.47"
					x2="376.17"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.17"
					y1="529.47"
					x2="376.17"
					y2="530.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.17"
					y1="530.77"
					x2="370.96"
					y2="530.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.96"
					y1="530.77"
					x2="370.96"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.64"
					y1="516.45"
					x2="269.43"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.43"
					y1="516.45"
					x2="269.43"
					y2="515.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.43"
					y1="515.15"
					x2="274.64"
					y2="515.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.64"
					y1="515.15"
					x2="274.64"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.96"
					y1="515.15"
					x2="376.17"
					y2="515.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.17"
					y1="515.15"
					x2="376.17"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.17"
					y1="516.45"
					x2="370.96"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.96"
					y1="516.45"
					x2="370.96"
					y2="515.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="275.94 529.47 275.94 516.45 273.99 516.45 273.99 529.47 275.94 529.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="371.61 529.47 371.61 516.45 369.66 516.45 369.66 529.47 371.61 529.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="303.39 450.18 300.17 453.4 366.44 519.67 369.66 516.45 303.39 450.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="273.99"
					y1="516.45"
					x2="273.34"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.99"
					y1="529.47"
					x2="273.34"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.34"
					y1="516.45"
					x2="273.34"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.61"
					y1="516.45"
					x2="372.26"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.61"
					y1="529.47"
					x2="372.26"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.26"
					y1="516.45"
					x2="372.26"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.94"
					y1="529.47"
					x2="275.94"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.94"
					y1="516.45"
					x2="273.99"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.99"
					y1="516.45"
					x2="273.99"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.99"
					y1="529.47"
					x2="275.94"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.61"
					y1="529.47"
					x2="371.61"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.61"
					y1="516.45"
					x2="369.66"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.66"
					y1="516.45"
					x2="369.66"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.66"
					y1="529.47"
					x2="371.61"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.39"
					y1="450.18"
					x2="300.17"
					y2="453.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.17"
					y1="453.4"
					x2="366.44"
					y2="519.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.44"
					y1="519.67"
					x2="369.66"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.66"
					y1="516.45"
					x2="303.39"
					y2="450.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.34"
					y1="516.45"
					x2="273.34"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="273.34"
					y1="516.45"
					x2="273.34"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="273.34"
					y1="516.45"
					x2="269.43"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="273.34"
					y1="516.45"
					x2="269.43"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="273.34"
					y1="529.47"
					x2="269.43"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="273.34"
					y1="529.47"
					x2="269.43"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="372.26"
					y1="516.45"
					x2="372.26"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="372.26"
					y1="516.45"
					x2="372.26"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="372.26"
					y1="516.45"
					x2="376.17"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="372.26"
					y1="516.45"
					x2="376.17"
					y2="516.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="372.26"
					y1="529.47"
					x2="376.17"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="372.26"
					y1="529.47"
					x2="376.17"
					y2="529.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="267.49"
					y1="111.27"
					x2="267.49"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="94.85"
					y1="111.27"
					x2="94.85"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="407.8"
					y1="111.27"
					x2="407.8"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="565.07"
					y1="111.27"
					x2="565.07"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<line
					x1="673.97"
					y1="132.1"
					x2="673.97"
					y2="111.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".29"
				/>
				<polyline
					points="331.98 770.84 327.33 768.77 322.3 768.05 317.26 768.77 312.61 770.84 309.55 773.47 307.23 776.77 304.28 784.52 303.24 790.96 303.63 797.46 305.43 803.72 304.72 812.27 301.16 820.06 299.76 822.26 298.11 826.79 298.35 831.6 299.1 833.5 299.1 838.55 301.21 838.55 301.21 836.25 304.74 838.38 308.77 839.21 335.82 839.21 341.05 837.8 344.97 834.07 346.65 828.93 346.65 828.31 346.12 825.06 343.37 819.94 339.84 812.24 339.13 803.79 340.95 797.51 341.35 790.98 340.31 784.52 337.36 776.77 335.04 773.47 331.98 770.84"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="312.66"
					y1="815.17"
					x2="331.93"
					y2="815.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.82"
					y1="839.21"
					x2="322.3"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.82"
					y1="838.23"
					x2="322.3"
					y2="838.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="308.77"
					y1="839.21"
					x2="322.3"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="308.77"
					y1="838.23"
					x2="322.3"
					y2="838.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.43"
					y1="815.17"
					x2="331.43"
					y2="818.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.43"
					y1="818.77"
					x2="328.45"
					y2="818.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.45"
					y1="818.77"
					x2="328.45"
					y2="815.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.16"
					y1="815.17"
					x2="313.16"
					y2="818.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.16"
					y1="818.77"
					x2="316.14"
					y2="818.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.14"
					y1="818.77"
					x2="316.14"
					y2="815.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="301.21"
					y1="829.6"
					x2="301.21"
					y2="838.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.1"
					y1="829.6"
					x2="299.1"
					y2="838.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.1"
					y1="838.55"
					x2="301.21"
					y2="838.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.1"
					y1="829.6"
					x2="301.21"
					y2="829.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.3"
					y1="768.05"
					x2="325.53"
					y2="768.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.53"
					y1="768.42"
					x2="328.65"
					y2="769.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.65"
					y1="769.25"
					x2="331.98"
					y2="770.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.98"
					y1="770.84"
					x2="333.61"
					y2="772.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.61"
					y1="772.06"
					x2="335.04"
					y2="773.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.04"
					y1="773.47"
					x2="337.36"
					y2="776.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.36"
					y1="776.77"
					x2="339.07"
					y2="780.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.07"
					y1="780.53"
					x2="340.31"
					y2="784.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.31"
					y1="784.52"
					x2="341.02"
					y2="787.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.02"
					y1="787.73"
					x2="341.44"
					y2="790.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.44"
					y1="790.97"
					x2="341.49"
					y2="794.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.49"
					y1="794.22"
					x2="341.13"
					y2="797.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.13"
					y1="797.46"
					x2="339.66"
					y2="802.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.66"
					y1="802.48"
					x2="337.39"
					y2="807.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.39"
					y1="807.35"
					x2="334.68"
					y2="811.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.68"
					y1="811.69"
					x2="331.93"
					y2="815.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.13"
					y1="803.79"
					x2="339.16"
					y2="808.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.16"
					y1="808.3"
					x2="339.91"
					y2="812.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.91"
					y1="812.69"
					x2="340.67"
					y2="815.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.67"
					y1="815.06"
					x2="341.77"
					y2="817.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.77"
					y1="817.4"
					x2="343.94"
					y2="820.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.94"
					y1="820.81"
					x2="345.86"
					y2="824.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.86"
					y1="824.34"
					x2="346.38"
					y2="826.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.38"
					y1="826.04"
					x2="346.63"
					y2="827.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.63"
					y1="827.79"
					x2="346.62"
					y2="829.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.62"
					y1="829.52"
					x2="346.34"
					y2="831.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.34"
					y1="831.22"
					x2="345.8"
					y2="832.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.8"
					y1="832.84"
					x2="345"
					y2="834.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345"
					y1="834.34"
					x2="343.95"
					y2="835.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.95"
					y1="835.69"
					x2="342.64"
					y2="836.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.64"
					y1="836.85"
					x2="340.33"
					y2="838.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.33"
					y1="838.13"
					x2="338.12"
					y2="838.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.12"
					y1="838.84"
					x2="335.82"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.82"
					y1="838.23"
					x2="336.85"
					y2="838.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.85"
					y1="838.13"
					x2="338.98"
					y2="837.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.98"
					y1="837.47"
					x2="340"
					y2="836.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340"
					y1="836.78"
					x2="340.85"
					y2="835.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.85"
					y1="835.89"
					x2="342.03"
					y2="833.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.03"
					y1="833.69"
					x2="342.59"
					y2="830.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.59"
					y1="830.79"
					x2="342.72"
					y2="827.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.72"
					y1="827.79"
					x2="342.7"
					y2="826.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.7"
					y1="826.31"
					x2="342.51"
					y2="825.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.51"
					y1="825.65"
					x2="342.07"
					y2="825.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.07"
					y1="825.13"
					x2="341.34"
					y2="824.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.34"
					y1="824.78"
					x2="337.29"
					y2="823.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.29"
					y1="823.5"
					x2="333.16"
					y2="822.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.16"
					y1="822.46"
					x2="329.1"
					y2="821.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.1"
					y1="821.77"
					x2="324.98"
					y2="821.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="324.98"
					y1="821.47"
					x2="322.3"
					y2="821.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.43"
					y1="803.72"
					x2="305.4"
					y2="808.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.4"
					y1="808.25"
					x2="304.66"
					y2="812.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.66"
					y1="812.66"
					x2="303.91"
					y2="815.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.91"
					y1="815.04"
					x2="302.82"
					y2="817.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.82"
					y1="817.4"
					x2="300.66"
					y2="820.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.66"
					y1="820.82"
					x2="298.73"
					y2="824.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.73"
					y1="824.34"
					x2="298.1"
					y2="826.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.1"
					y1="826.64"
					x2="297.95"
					y2="829"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.95"
					y1="829"
					x2="298.28"
					y2="831.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.28"
					y1="831.33"
					x2="299.1"
					y2="833.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="308.77"
					y1="838.23"
					x2="307.74"
					y2="838.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.74"
					y1="838.13"
					x2="305.62"
					y2="837.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.62"
					y1="837.47"
					x2="304.59"
					y2="836.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.59"
					y1="836.78"
					x2="303.74"
					y2="835.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.74"
					y1="835.89"
					x2="302.56"
					y2="833.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.56"
					y1="833.69"
					x2="302"
					y2="830.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302"
					y1="830.79"
					x2="301.87"
					y2="827.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="301.87"
					y1="827.79"
					x2="301.89"
					y2="826.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="301.89"
					y1="826.31"
					x2="302.09"
					y2="825.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.09"
					y1="825.65"
					x2="302.52"
					y2="825.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.52"
					y1="825.13"
					x2="303.25"
					y2="824.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.25"
					y1="824.78"
					x2="307.31"
					y2="823.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.31"
					y1="823.5"
					x2="311.43"
					y2="822.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.43"
					y1="822.46"
					x2="315.5"
					y2="821.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.5"
					y1="821.77"
					x2="319.61"
					y2="821.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.61"
					y1="821.47"
					x2="322.3"
					y2="821.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.3"
					y1="768.05"
					x2="319.07"
					y2="768.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.07"
					y1="768.42"
					x2="315.94"
					y2="769.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.94"
					y1="769.25"
					x2="312.61"
					y2="770.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.61"
					y1="770.84"
					x2="310.98"
					y2="772.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.98"
					y1="772.06"
					x2="309.55"
					y2="773.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.55"
					y1="773.47"
					x2="307.23"
					y2="776.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.23"
					y1="776.77"
					x2="305.52"
					y2="780.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.52"
					y1="780.53"
					x2="304.28"
					y2="784.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.28"
					y1="784.52"
					x2="303.57"
					y2="787.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.57"
					y1="787.73"
					x2="303.16"
					y2="790.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.16"
					y1="790.97"
					x2="303.1"
					y2="794.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.1"
					y1="794.22"
					x2="303.46"
					y2="797.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.46"
					y1="797.46"
					x2="304.93"
					y2="802.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.93"
					y1="802.48"
					x2="307.21"
					y2="807.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.21"
					y1="807.35"
					x2="309.91"
					y2="811.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.91"
					y1="811.69"
					x2="312.66"
					y2="815.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.96"
					y1="822.46"
					x2="344.44"
					y2="821.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.44"
					y1="821.73"
					x2="342.95"
					y2="820.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.95"
					y1="820.63"
					x2="341.66"
					y2="820.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.66"
					y1="820.37"
					x2="333.35"
					y2="819.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.35"
					y1="819.66"
					x2="325.02"
					y2="819.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.02"
					y1="819.34"
					x2="322.3"
					y2="819.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.63"
					y1="822.46"
					x2="300.15"
					y2="821.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.15"
					y1="821.73"
					x2="301.64"
					y2="820.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="301.64"
					y1="820.63"
					x2="302.93"
					y2="820.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.93"
					y1="820.37"
					x2="311.24"
					y2="819.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.24"
					y1="819.66"
					x2="319.57"
					y2="819.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.57"
					y1="819.34"
					x2="322.3"
					y2="819.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="301.21"
					y1="836.25"
					x2="301.95"
					y2="836.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="301.95"
					y1="836.85"
					x2="304.26"
					y2="838.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.26"
					y1="838.13"
					x2="306.47"
					y2="838.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="306.47"
					y1="838.84"
					x2="308.77"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="353.54 839.21 353.54 838.17 348.33 838.17 348.33 839.21 353.54 839.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="348.33"
					y1="839.21"
					x2="353.54"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.33"
					y1="838.17"
					x2="348.33"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.54"
					y1="838.17"
					x2="348.33"
					y2="838.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.54"
					y1="839.21"
					x2="353.54"
					y2="838.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="291.06 839.21 296.26 839.21 296.26 838.17 291.06 838.17 291.06 839.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="291.06"
					y1="838.17"
					x2="291.06"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="296.26"
					y1="838.17"
					x2="291.06"
					y2="838.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="296.26"
					y1="839.21"
					x2="296.26"
					y2="838.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.06"
					y1="839.21"
					x2="296.26"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="351.45 838.17 351.45 829.7 350.41 829.7 350.41 838.17 351.45 838.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="350.41"
					y1="838.17"
					x2="351.45"
					y2="838.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.41"
					y1="829.7"
					x2="350.41"
					y2="838.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.45"
					y1="829.7"
					x2="350.41"
					y2="829.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.45"
					y1="838.17"
					x2="351.45"
					y2="829.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="293.14 838.17 294.18 838.17 294.18 829.7 293.14 829.7 293.14 838.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="293.14"
					y1="829.7"
					x2="293.14"
					y2="838.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.18"
					y1="829.7"
					x2="293.14"
					y2="829.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.18"
					y1="838.17"
					x2="294.18"
					y2="829.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="293.14"
					y1="838.17"
					x2="294.18"
					y2="838.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="350.41 832.3 350.41 830.22 294.18 830.22 294.18 832.3 350.41 832.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="294.18"
					y1="832.3"
					x2="350.41"
					y2="832.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.18"
					y1="830.22"
					x2="294.18"
					y2="832.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.41"
					y1="830.22"
					x2="294.18"
					y2="830.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.41"
					y1="832.3"
					x2="350.41"
					y2="830.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="205.28 664.6 125.34 664.6 125.34 819.42 205.28 819.42 205.28 664.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="205.28"
					y1="819.42"
					x2="205.28"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="125.34"
					y1="819.42"
					x2="205.28"
					y2="819.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="125.34"
					y1="664.6"
					x2="125.34"
					y2="819.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.28"
					y1="664.6"
					x2="125.34"
					y2="664.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.15"
					y1="814.3"
					x2="200.15"
					y2="669.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.15"
					y1="669.73"
					x2="130.46"
					y2="669.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.46"
					y1="669.73"
					x2="130.46"
					y2="814.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.46"
					y1="814.3"
					x2="200.15"
					y2="814.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.15"
					y1="814.3"
					x2="168.63"
					y2="749.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.46"
					y1="814.3"
					x2="161.99"
					y2="749.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.15"
					y1="669.73"
					x2="168.63"
					y2="734.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.46"
					y1="669.73"
					x2="161.99"
					y2="734.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="170.43"
					y1="742.01"
					x2="160.18"
					y2="742.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.31"
					y1="736.89"
					x2="165.31"
					y2="747.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m173.51,742.01c0-4.53-3.67-8.2-8.2-8.2s-8.2,3.67-8.2,8.2,3.67,8.2,8.2,8.2,8.2-3.67,8.2-8.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m170.43,742.01c0-2.83-2.29-5.12-5.12-5.12s-5.12,2.29-5.12,5.12,2.29,5.13,5.12,5.13,5.12-2.29,5.12-5.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="165.31 819.42 173.31 808.55 157.31 808.55 165.31 819.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="157.31"
					y1="808.55"
					x2="165.31"
					y2="819.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="173.31"
					y1="808.55"
					x2="157.31"
					y2="808.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.31"
					y1="819.42"
					x2="173.31"
					y2="808.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.31"
					y1="806.06"
					x2="165.31"
					y2="799.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.31"
					y1="808.55"
					x2="157.31"
					y2="808.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.31"
					y1="808.55"
					x2="165.31"
					y2="819.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.31"
					y1="808.55"
					x2="173.31"
					y2="808.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="173.31"
					y1="808.55"
					x2="165.31"
					y2="819.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="162.95"
					y1="806.27"
					x2="159.63"
					y2="800.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.67"
					y1="806.27"
					x2="170.99"
					y2="800.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="842.43 270.72 901.83 270.72 901.83 212.34 842.43 212.34 842.43 270.72"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="842.43"
					y1="212.34"
					x2="842.43"
					y2="214.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="842.43"
					y1="218.41"
					x2="842.43"
					y2="224.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="842.43"
					y1="228.41"
					x2="842.43"
					y2="234.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="842.43"
					y1="238.41"
					x2="842.43"
					y2="244.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="842.43"
					y1="248.4"
					x2="842.43"
					y2="254.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="842.43"
					y1="258.4"
					x2="842.43"
					y2="264.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="842.43"
					y1="268.4"
					x2="842.43"
					y2="270.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.83"
					y1="212.34"
					x2="898.99"
					y2="212.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.25"
					y1="212.34"
					x2="889"
					y2="212.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="885.25"
					y1="212.34"
					x2="879"
					y2="212.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.25"
					y1="212.34"
					x2="869"
					y2="212.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="865.26"
					y1="212.34"
					x2="859.01"
					y2="212.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.26"
					y1="212.34"
					x2="849.01"
					y2="212.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="845.26"
					y1="212.34"
					x2="842.43"
					y2="212.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.83"
					y1="270.72"
					x2="901.83"
					y2="268.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.83"
					y1="264.65"
					x2="901.83"
					y2="258.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.83"
					y1="254.65"
					x2="901.83"
					y2="248.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.83"
					y1="244.66"
					x2="901.83"
					y2="238.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.83"
					y1="234.66"
					x2="901.83"
					y2="228.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.83"
					y1="224.66"
					x2="901.83"
					y2="218.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.83"
					y1="214.67"
					x2="901.83"
					y2="212.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="842.43"
					y1="270.72"
					x2="845.26"
					y2="270.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.01"
					y1="270.72"
					x2="855.26"
					y2="270.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.01"
					y1="270.72"
					x2="865.26"
					y2="270.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="869"
					y1="270.72"
					x2="875.25"
					y2="270.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879"
					y1="270.72"
					x2="885.25"
					y2="270.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="889"
					y1="270.72"
					x2="895.25"
					y2="270.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.99"
					y1="270.72"
					x2="901.83"
					y2="270.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="839.35 212.56 837.56 212.56 837.56 270.5 839.35 270.5 839.35 261.41 837.88 261.41 837.88 221.65 839.35 221.65 839.35 212.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="839.35"
					y1="221.65"
					x2="839.35"
					y2="212.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="837.88"
					y1="221.65"
					x2="839.35"
					y2="221.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="837.88"
					y1="261.41"
					x2="837.88"
					y2="221.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="839.35"
					y1="261.41"
					x2="837.88"
					y2="261.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="839.35"
					y1="270.5"
					x2="839.35"
					y2="261.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="837.56"
					y1="270.5"
					x2="839.35"
					y2="270.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="837.56"
					y1="212.56"
					x2="837.56"
					y2="270.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="839.35"
					y1="212.56"
					x2="837.56"
					y2="212.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<polyline
					points="839.35 210.29 839.35 272.77 842.43 272.77 842.43 210.29 839.35 210.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="842.43"
					y1="210.29"
					x2="839.35"
					y2="210.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="842.43"
					y1="272.77"
					x2="842.43"
					y2="210.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="839.35"
					y1="272.77"
					x2="842.43"
					y2="272.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="839.35"
					y1="210.29"
					x2="839.35"
					y2="272.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".21"
				/>
				<line
					x1="839.35"
					y1="270.5"
					x2="837.56"
					y2="270.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.56"
					y1="270.5"
					x2="837.56"
					y2="212.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.56"
					y1="212.56"
					x2="839.35"
					y2="212.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.35"
					y1="272.77"
					x2="839.35"
					y2="210.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.35"
					y1="221.65"
					x2="837.88"
					y2="221.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.88"
					y1="221.65"
					x2="837.88"
					y2="261.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.88"
					y1="261.41"
					x2="839.35"
					y2="261.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="842.43"
					y1="272.77"
					x2="839.35"
					y2="272.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.35"
					y1="210.29"
					x2="842.43"
					y2="210.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="842.43"
					y1="210.29"
					x2="842.43"
					y2="272.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="829.95 543.88 829.95 456.41 929.18 456.41 929.18 543.88 829.95 543.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="829.95"
					y1="543.88"
					x2="829.95"
					y2="456.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.95"
					y1="456.41"
					x2="929.18"
					y2="456.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="929.18"
					y1="456.41"
					x2="929.18"
					y2="543.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="929.18"
					y1="543.88"
					x2="829.95"
					y2="543.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="836.46"
					y1="543.88"
					x2="836.46"
					y2="456.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="846.84 280.2 846.84 345.05 847.11 346.07 847.86 346.82 848.89 347.09 892.3 347.09 893.32 346.82 894.07 346.07 894.35 345.05 894.35 280.2 894.07 279.17 893.32 278.42 892.3 278.15 848.89 278.15 847.86 278.42 847.11 279.17 846.84 280.2"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m846.84,280.2c0-1.13.92-2.05,2.05-2.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.3"
					y1="278.15"
					x2="848.89"
					y2="278.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m892.3,278.15c1.13,0,2.05.92,2.05,2.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.35"
					y1="345.05"
					x2="894.35"
					y2="280.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m894.35,345.05c0,1.13-.92,2.05-2.05,2.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.89"
					y1="347.09"
					x2="892.3"
					y2="347.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m848.89,347.09c-1.13,0-2.05-.92-2.05-2.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.84"
					y1="280.2"
					x2="846.84"
					y2="345.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="851.96"
					y1="285.32"
					x2="851.96"
					y2="339.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.01"
					y1="341.97"
					x2="882.05"
					y2="341.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.1"
					y1="339.92"
					x2="884.1"
					y2="285.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.05"
					y1="283.27"
					x2="854.01"
					y2="283.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="851.96"
					y1="285.32"
					x2="851.96"
					y2="285.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m854.01,341.97c-1.13,0-2.05-.92-2.05-2.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m884.1,339.92c0,1.13-.92,2.05-2.05,2.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m882.05,283.27c1.13,0,2.05.92,2.05,2.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m851.96,285.32c0-1.13.92-2.05,2.05-2.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m876.92,312.62c0-1.7-1.38-3.07-3.07-3.07s-3.08,1.38-3.08,3.07,1.38,3.07,3.08,3.07,3.07-1.38,3.07-3.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="870.99 311.7 870.34 311.97 870.07 312.62 870.34 313.28 870.99 313.54 891.27 313.54 891.92 313.27 892.19 312.62 891.92 311.97 891.27 311.7 870.99 311.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="891.27"
					y1="311.7"
					x2="870.99"
					y2="311.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m891.27,311.7c.51,0,.92.41.92.92s-.41.92-.92.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.99"
					y1="313.54"
					x2="891.27"
					y2="313.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m870.99,313.54h0c-.51,0-.92-.41-.92-.92s.41-.92.92-.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="886.04 310.58 886.04 311.7 891.27 311.7 891.92 311.97 892.19 312.62 891.92 313.27 891.27 313.54 886.04 313.54 886.04 314.67 892.71 314.67 892.71 310.58 886.04 310.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="892.71"
					y1="310.58"
					x2="886.04"
					y2="310.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.71"
					y1="314.67"
					x2="892.71"
					y2="310.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.04"
					y1="314.67"
					x2="892.71"
					y2="314.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.04"
					y1="313.54"
					x2="886.04"
					y2="314.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.27"
					y1="313.54"
					x2="886.04"
					y2="313.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m891.27,311.7c.51,0,.92.41.92.92s-.41.92-.92.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.04"
					y1="311.7"
					x2="891.27"
					y2="311.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.04"
					y1="310.58"
					x2="886.04"
					y2="311.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="882.35 310.6 882.35 311.7 885.94 311.7 885.94 310.6 882.35 310.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="885.94"
					y1="310.6"
					x2="882.35"
					y2="310.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="885.94"
					y1="311.7"
					x2="885.94"
					y2="310.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.35"
					y1="311.7"
					x2="885.94"
					y2="311.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.35"
					y1="310.6"
					x2="882.35"
					y2="311.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="882.35 314.64 885.94 314.64 885.94 313.54 882.35 313.54 882.35 314.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="882.35"
					y1="313.54"
					x2="882.35"
					y2="314.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="885.94"
					y1="313.54"
					x2="882.35"
					y2="313.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="885.94"
					y1="314.64"
					x2="885.94"
					y2="313.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.35"
					y1="314.64"
					x2="885.94"
					y2="314.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="276.42 787.17 208.73 787.17 208.73 839.21 276.42 839.21 276.42 787.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="276.42"
					y1="787.17"
					x2="208.73"
					y2="787.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.42"
					y1="839.21"
					x2="208.73"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.73"
					y1="787.17"
					x2="208.73"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.42"
					y1="787.17"
					x2="276.42"
					y2="839.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.42"
					y1="837.16"
					x2="208.73"
					y2="837.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.61"
					y1="799.52"
					x2="216.54"
					y2="799.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.54"
					y1="799.52"
					x2="216.54"
					y2="830.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.54"
					y1="830.76"
					x2="268.61"
					y2="830.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.61"
					y1="830.76"
					x2="268.61"
					y2="799.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.66"
					y1="797.47"
					x2="214.49"
					y2="797.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.49"
					y1="797.47"
					x2="214.49"
					y2="832.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.49"
					y1="832.81"
					x2="270.66"
					y2="832.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.66"
					y1="832.81"
					x2="270.66"
					y2="797.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m245.65,823.71c0-1.7-1.38-3.07-3.07-3.07s-3.07,1.38-3.07,3.07,1.38,3.07,3.07,3.07,3.07-1.38,3.07-3.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="245.14 836.4 244.73 832.09 244.39 831.12 243.71 825.69 243.33 824.98 242.58 824.69 241.82 824.98 241.44 825.69 240.76 831.12 240.42 832.09 240.01 836.4 240.36 837.68 241.29 838.61 242.58 838.96 243.86 838.61 244.79 837.68 245.14 836.4"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m245.14,836.4c0,1.42-1.15,2.56-2.56,2.56s-2.56-1.15-2.56-2.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.42"
					y1="832.09"
					x2="240.01"
					y2="836.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m240.42,832.09c.03-.35.15-.68.34-.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.44"
					y1="825.69"
					x2="240.76"
					y2="831.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m241.44,825.69c.07-.57.56-1,1.14-1s1.07.43,1.14,1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.39"
					y1="831.12"
					x2="243.71"
					y2="825.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m244.39,831.12c.19.29.3.63.34.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.14"
					y1="836.4"
					x2="244.73"
					y2="832.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.18"
					y1="833.84"
					x2="241.18"
					y2="832.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.97"
					y1="832.32"
					x2="243.97"
					y2="833.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.97"
					y1="833.84"
					x2="241.18"
					y2="833.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m241.18,832.32c0-.77.62-1.39,1.39-1.39s1.39.62,1.39,1.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m240.76,831.12c.4-.62,1.08-.99,1.82-.99s1.42.38,1.82.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.97"
					y1="786.25"
					x2="445.65"
					y2="786.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.65"
					y1="786.25"
					x2="445.65"
					y2="831.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.97"
					y1="776.72"
					x2="428.97"
					y2="841.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.09"
					y1="841.04"
					x2="386.09"
					y2="776.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.09"
					y1="776.72"
					x2="450.41"
					y2="776.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.41"
					y1="841.04"
					x2="386.09"
					y2="841.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.22"
					y1="776.72"
					x2="449.22"
					y2="841.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.97"
					y1="831.51"
					x2="445.65"
					y2="831.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.41"
					y1="776.72"
					x2="450.41"
					y2="841.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.95"
					y1="459.33"
					x2="824.19"
					y2="459.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.19"
					y1="459.33"
					x2="824.19"
					y2="462.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.19"
					y1="462.24"
					x2="829.95"
					y2="462.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.35"
					y1="543.88"
					x2="839.35"
					y2="541.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.35"
					y1="538.26"
					x2="839.35"
					y2="532.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.35"
					y1="528.26"
					x2="839.35"
					y2="522.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.35"
					y1="518.27"
					x2="839.35"
					y2="512.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.35"
					y1="508.27"
					x2="839.35"
					y2="502.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.35"
					y1="498.27"
					x2="839.35"
					y2="492.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.35"
					y1="488.28"
					x2="839.35"
					y2="482.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.35"
					y1="478.28"
					x2="839.35"
					y2="472.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.35"
					y1="468.28"
					x2="839.35"
					y2="462.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.35"
					y1="458.35"
					x2="839.35"
					y2="456.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.35"
					y1="208.57"
					x2="839.35"
					y2="456.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.85"
					y1="111.27"
					x2="267.49"
					y2="111.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.49"
					y1="132.1"
					x2="94.85"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.8"
					y1="111.27"
					x2="565.07"
					y2="111.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.07"
					y1="132.1"
					x2="407.8"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.87"
					y1="132.1"
					x2="673.97"
					y2="132.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.97"
					y1="111.27"
					x2="846.87"
					y2="111.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.24"
					y1="786.25"
					x2="393.24"
					y2="831.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.24"
					y1="831.51"
					x2="424.2"
					y2="831.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.2"
					y1="831.51"
					x2="424.2"
					y2="786.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.2"
					y1="786.25"
					x2="393.24"
					y2="786.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="834.15 352.47 834.15 430.57 901.83 430.57 901.83 352.47 834.15 352.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="834.15"
					y1="352.47"
					x2="834.15"
					y2="430.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.83"
					y1="352.47"
					x2="901.83"
					y2="430.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="899.78"
					y1="352.47"
					x2="899.78"
					y2="430.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="834.15"
					y1="352.47"
					x2="901.83"
					y2="352.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="834.15"
					y1="430.57"
					x2="901.83"
					y2="430.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.22"
					y1="357.6"
					x2="837.22"
					y2="425.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.22"
					y1="425.45"
					x2="839.27"
					y2="427.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.27"
					y1="427.5"
					x2="896.71"
					y2="427.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="896.71"
					y1="427.5"
					x2="898.76"
					y2="425.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.76"
					y1="425.45"
					x2="898.76"
					y2="357.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.76"
					y1="357.6"
					x2="896.71"
					y2="355.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="896.71"
					y1="355.55"
					x2="839.27"
					y2="355.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.27"
					y1="355.55"
					x2="837.22"
					y2="357.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m861.32,372c0-5.66-4.59-10.25-10.25-10.25s-10.25,4.59-10.25,10.25,4.59,10.25,10.25,10.25,10.25-4.59,10.25-10.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m892.59,372c0-4.25-3.44-7.69-7.69-7.69s-7.69,3.44-7.69,7.69,3.44,7.69,7.69,7.69,7.69-3.44,7.69-7.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m858.75,411.05c0-4.25-3.44-7.69-7.69-7.69s-7.69,3.44-7.69,7.69,3.44,7.69,7.69,7.69,7.69-3.44,7.69-7.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m895.16,411.05c0-5.66-4.59-10.25-10.25-10.25s-10.25,4.59-10.25,10.25,4.59,10.25,10.25,10.25,10.25-4.59,10.25-10.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="208.57"
					x2="870.59"
					y2="210.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="214.41"
					x2="870.59"
					y2="220.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="224.4"
					x2="870.59"
					y2="230.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="234.4"
					x2="870.59"
					y2="240.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="244.4"
					x2="870.59"
					y2="250.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="254.39"
					x2="870.59"
					y2="260.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="264.39"
					x2="870.59"
					y2="270.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="274.39"
					x2="870.59"
					y2="280.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="284.38"
					x2="870.59"
					y2="290.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="294.38"
					x2="870.59"
					y2="300.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="304.38"
					x2="870.59"
					y2="310.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="314.37"
					x2="870.59"
					y2="320.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="324.37"
					x2="870.59"
					y2="330.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="334.37"
					x2="870.59"
					y2="340.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="344.36"
					x2="870.59"
					y2="350.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="354.36"
					x2="870.59"
					y2="360.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="364.36"
					x2="870.59"
					y2="370.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="374.35"
					x2="870.59"
					y2="380.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="384.35"
					x2="870.59"
					y2="390.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="394.34"
					x2="870.59"
					y2="400.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="404.34"
					x2="870.59"
					y2="410.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="414.34"
					x2="870.59"
					y2="420.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="424.33"
					x2="870.59"
					y2="430.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="434.33"
					x2="870.59"
					y2="440.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="444.33"
					x2="870.59"
					y2="450.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.59"
					y1="454.33"
					x2="870.59"
					y2="456.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="950 111.26 950 564.71 680.13 564.71 680.13 887.43 650.35 887.43 650.35 866.6 659.31 866.6 659.31 543.88 929.17 543.88 929.17 456.41 901.83 456.41 901.83 208.57 874.55 208.57 874.55 132.09 846.87 132.09 846.87 111.26 950 111.26"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.33"
				/>
				<polygon
					points="551.43 866.6 551.43 887.43 483.91 887.43 483.91 867.34 50 867.34 50 111.26 94.85 111.26 94.85 132.09 70.83 132.09 70.83 484.68 114.14 484.68 114.14 497.7 70.83 497.7 70.83 651.58 220.21 651.58 220.21 497.7 213.05 497.7 213.05 484.68 233.23 484.68 233.23 516.45 273.34 516.45 273.34 529.47 233.23 529.47 233.23 651.58 261.46 651.58 261.46 664.61 125.34 664.61 125.34 819.42 205.28 819.42 205.28 839.2 365.58 839.2 365.58 664.61 360.39 664.61 360.39 651.58 387.42 651.58 387.42 664.61 378.59 664.61 378.59 724.7 455.6 724.7 455.6 664.61 449.89 664.61 449.89 651.58 468.62 651.58 468.62 774.49 455.6 774.49 455.6 770.17 378.59 770.17 378.59 846.51 455.6 846.51 455.6 842.18 468.62 842.18 468.62 846.51 504.74 846.51 504.74 866.6 551.43 866.6"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.33"
				/>
				<polygon
					points="407.79 111.26 407.79 529.47 372.26 529.47 372.26 516.45 394.78 516.45 394.78 228.89 313.14 228.89 313.14 208.81 267.49 208.81 267.49 111.26 407.79 111.26"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.33"
				/>
				<polygon
					points="673.97 111.27 673.97 132.1 565.07 132.1 565.07 111.27 673.97 111.27 673.97 111.27"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.33"
				/>
			</g>
			<g id="text">
				<path d="m872.63,246.98v-12.08h4.16c.94,0,1.66.06,2.15.17.69.16,1.28.45,1.77.87.64.54,1.11,1.23,1.43,2.07.32.83.48,1.79.48,2.87,0,.92-.11,1.73-.32,2.44-.21.71-.49,1.3-.82,1.76-.34.46-.7.83-1.1,1.1-.4.26-.88.46-1.44.6-.56.14-1.21.21-1.94.21h-4.36Zm1.6-1.43h2.58c.8,0,1.42-.07,1.87-.22.46-.15.82-.36,1.09-.63.38-.38.67-.89.88-1.52.21-.64.32-1.42.32-2.33,0-1.26-.21-2.23-.63-2.91-.41-.68-.91-1.14-1.51-1.37-.43-.16-1.12-.25-2.07-.25h-2.54v9.23Zm12.69,1.43l-3.2-12.08h1.64l1.84,7.92c.2.83.37,1.65.51,2.47.31-1.29.49-2.04.54-2.23l2.3-8.16h1.93l1.73,6.11c.43,1.52.75,2.94.94,4.28.15-.76.35-1.64.6-2.63l1.9-7.76h1.61l-3.31,12.08h-1.54l-2.55-9.2c-.21-.77-.34-1.24-.38-1.42-.13.55-.24,1.03-.35,1.42l-2.56,9.2h-1.63Z" />
				<path d="m875.75,507.38h-1.7l-2.03-3.41c-.19-.32-.37-.58-.54-.81-.18-.23-.36-.41-.54-.55-.18-.14-.38-.24-.59-.31-.21-.07-.45-.1-.71-.1h-1.17v5.17h-1.42v-12.15h3.63c.53,0,1.02.07,1.47.2.45.13.84.33,1.17.6.33.27.59.61.78,1.02.19.4.28.87.28,1.42,0,.42-.06.81-.19,1.17-.12.35-.31.66-.54.94-.23.28-.51.51-.85.71-.33.19-.7.34-1.11.45v.03c.2.09.38.19.53.31.15.11.3.25.43.41.14.16.27.34.4.54.14.2.29.43.45.69l2.28,3.65Zm-7.29-10.87v4.41h1.93c.36,0,.68-.05.98-.16.31-.11.57-.26.79-.46.22-.2.39-.45.52-.74.12-.29.19-.62.19-.98,0-.65-.21-1.16-.64-1.52-.42-.37-1.03-.55-1.82-.55h-1.95Zm15.59,6.87h-6.13c.02.97.28,1.71.78,2.24.5.53,1.18.79,2.05.79.98,0,1.88-.32,2.7-.97v1.31c-.76.55-1.77.83-3.03.83s-2.19-.39-2.89-1.18c-.7-.79-1.05-1.9-1.05-3.33,0-1.35.38-2.45,1.14-3.3.77-.85,1.72-1.28,2.86-1.28s2.01.37,2.64,1.1c.62.73.93,1.75.93,3.06v.73Zm-1.42-1.18c0-.8-.2-1.43-.58-1.87-.38-.45-.91-.67-1.58-.67s-1.21.23-1.67.7c-.46.47-.74,1.08-.85,1.84h4.69Zm7.66-6.46c-.27-.15-.58-.23-.92-.23-.97,0-1.46.61-1.46,1.84v1.34h2.03v1.19h-2.03v7.49h-1.38v-7.49h-1.48v-1.19h1.48v-1.41c0-.91.26-1.63.79-2.15.53-.53,1.18-.8,1.97-.8.42,0,.76.05,1.01.15v1.25Z" />
				<path d="m891.76,507.57c-.26,0-.48-.09-.67-.28-.18-.19-.27-.41-.27-.67s.09-.48.27-.67c.19-.19.41-.29.67-.29s.49.1.68.29c.19.19.28.41.28.67s-.09.48-.28.67c-.19.19-.41.28-.68.28Z" />
				<path d="m261.13,759.69v-18.87h5.37c1.63,0,2.93.4,3.88,1.2.96.8,1.43,1.84,1.43,3.12,0,1.07-.29,2-.87,2.79-.58.79-1.38,1.35-2.4,1.68v.05c1.27.15,2.29.63,3.05,1.45.76.81,1.15,1.86,1.15,3.16,0,1.61-.58,2.92-1.74,3.92-1.16,1-2.62,1.5-4.38,1.5h-5.5Zm2.21-16.87v6.09h2.26c1.21,0,2.16-.29,2.86-.87.69-.59,1.04-1.41,1.04-2.47,0-1.83-1.21-2.75-3.62-2.75h-2.54Zm0,8.08v6.79h3c1.3,0,2.3-.31,3.01-.92.72-.61,1.08-1.46,1.08-2.53,0-2.23-1.52-3.34-4.55-3.34h-2.54Zm22.59,8.79h-2.16v-2.11h-.05c-.94,1.61-2.32,2.42-4.15,2.42-1.34,0-2.4-.36-3.16-1.07-.75-.71-1.13-1.65-1.13-2.83,0-2.52,1.48-3.98,4.45-4.4l4.04-.57c0-2.29-.93-3.44-2.78-3.44-1.62,0-3.09.55-4.4,1.66v-2.21c1.32-.84,2.85-1.26,4.58-1.26,3.17,0,4.75,1.68,4.75,5.03v8.77Zm-2.16-6.82l-3.25.45c-1,.14-1.75.39-2.26.75-.51.35-.76.98-.76,1.88,0,.66.23,1.2.7,1.62.47.41,1.1.62,1.88.62,1.07,0,1.95-.37,2.65-1.12.7-.75,1.05-1.71,1.05-2.86v-1.34Zm12.48,6.69c-.51.28-1.18.42-2.01.42-2.36,0-3.54-1.32-3.54-3.95v-7.98h-2.32v-1.84h2.32v-3.29l2.16-.7v3.99h3.4v1.84h-3.4v7.59c0,.9.15,1.55.46,1.93.31.39.82.58,1.53.58.54,0,1.01-.15,1.41-.45v1.84Zm14.07.13h-2.16v-7.76c0-2.81-1.04-4.21-3.13-4.21-1.05,0-1.94.41-2.66,1.22-.72.81-1.08,1.85-1.08,3.12v7.63h-2.16v-19.95h2.16v8.71h.05c1.04-1.7,2.51-2.55,4.42-2.55,3.04,0,4.55,1.83,4.55,5.49v8.3Z" />
				<path d="m150.05,568.26l-3.88,13.72h-1.89l-2.82-10.03c-.12-.43-.19-.89-.22-1.4h-.04c-.04.47-.12.93-.25,1.38l-2.84,10.05h-1.87l-4.02-13.72h1.77l2.92,10.53c.12.44.2.9.23,1.38h.05c.03-.34.13-.8.3-1.38l3.03-10.53h1.54l2.91,10.6c.1.36.18.79.23,1.28h.04c.03-.33.11-.77.26-1.32l2.8-10.56h1.74Zm8.64,13.72h-1.57v-1.53h-.04c-.68,1.17-1.69,1.76-3.01,1.76-.98,0-1.74-.26-2.3-.78-.55-.52-.82-1.2-.82-2.06,0-1.83,1.08-2.9,3.23-3.2l2.94-.41c0-1.66-.67-2.5-2.02-2.5-1.18,0-2.25.4-3.2,1.21v-1.61c.96-.61,2.07-.92,3.33-.92,2.3,0,3.45,1.22,3.45,3.66v6.37Zm-1.57-4.96l-2.36.33c-.73.1-1.28.28-1.65.55-.37.26-.55.71-.55,1.37,0,.48.17.87.51,1.18.34.3.8.45,1.37.45.78,0,1.42-.27,1.92-.81.51-.55.77-1.24.77-2.08v-.98Zm5.9,4.96h-1.57v-14.51h1.57v14.51Zm11.1,0h-2.2l-4.33-4.71h-.04v4.71h-1.57v-14.51h1.57v9.2h.04l4.11-4.49h2.06l-4.55,4.73,4.9,5.07Z" />
				<rect x="175.31" y="575.9" width="5.22" height="1.23" />
				<path d="m185.17,581.98h-1.61v-13.72h1.61v13.72Zm11.54,0h-1.57v-5.59c0-2.08-.76-3.12-2.28-3.12-.78,0-1.44.3-1.95.89-.51.59-.77,1.33-.77,2.23v5.59h-1.57v-9.8h1.57v1.63h.04c.74-1.24,1.81-1.86,3.22-1.86,1.07,0,1.89.35,2.46,1.04.57.69.85,1.69.85,3v5.99Z" />
				<path d="m149.39,607.54c-1.01.54-2.28.8-3.79.8-1.95,0-3.51-.63-4.69-1.89-1.17-1.26-1.76-2.91-1.76-4.95,0-2.19.66-3.97,1.98-5.32,1.32-1.35,3-2.03,5.02-2.03,1.3,0,2.38.19,3.23.56v1.71c-.98-.55-2.07-.82-3.25-.82-1.58,0-2.85.53-3.84,1.58-.98,1.05-1.46,2.46-1.46,4.22s.46,3,1.37,4c.92.99,2.12,1.48,3.61,1.48,1.38,0,2.57-.31,3.58-.92v1.56Zm4.15.57h-1.57v-14.51h1.57v14.51Zm7.27.23c-1.45,0-2.61-.46-3.47-1.37-.86-.92-1.29-2.13-1.29-3.65,0-1.65.45-2.93,1.35-3.86.9-.92,2.11-1.39,3.65-1.39s2.6.45,3.42,1.35c.82.9,1.23,2.15,1.23,3.74s-.44,2.82-1.33,3.76c-.88.94-2.06,1.41-3.55,1.41Zm.11-8.94c-1.01,0-1.81.34-2.39,1.03-.59.68-.88,1.63-.88,2.83s.3,2.08.89,2.75c.59.67,1.39,1,2.38,1s1.79-.33,2.33-.99c.55-.66.82-1.59.82-2.8s-.27-2.17-.82-2.83c-.54-.66-1.32-1-2.33-1Zm6.68,8.35v-1.68c.85.63,1.8.95,2.82.95,1.38,0,2.07-.46,2.07-1.38,0-.26-.06-.48-.18-.66-.11-.19-.27-.35-.48-.49-.2-.14-.43-.26-.71-.37-.27-.11-.56-.23-.87-.35-.43-.17-.82-.34-1.15-.52-.33-.18-.6-.38-.82-.59-.22-.22-.38-.48-.5-.76-.11-.28-.16-.61-.16-.99,0-.46.11-.86.32-1.22.21-.36.49-.65.84-.89.35-.24.75-.42,1.2-.55.45-.12.92-.18,1.4-.18.85,0,1.61.15,2.28.44v1.59c-.72-.47-1.55-.71-2.49-.71-.29,0-.56.04-.79.11-.24.06-.44.16-.61.28-.17.12-.3.27-.39.44-.09.17-.13.35-.13.56,0,.26.04.47.13.64.1.17.23.33.41.46.18.13.4.26.65.36s.55.23.87.35c.43.17.82.34,1.17.52.34.17.64.37.88.59.24.22.43.47.55.76.13.29.2.63.2,1.02,0,.48-.11.91-.33,1.26-.21.36-.49.65-.85.89-.36.24-.77.41-1.23.53-.47.11-.95.17-1.46.17-1.01,0-1.88-.19-2.62-.58Zm16.78-4.15h-6.92c.03,1.09.32,1.93.88,2.53.56.59,1.33.89,2.32.89,1.1,0,2.12-.36,3.04-1.09v1.47c-.86.63-2,.94-3.42.94s-2.47-.44-3.26-1.33c-.79-.89-1.19-2.15-1.19-3.76,0-1.52.43-2.77,1.29-3.72.87-.96,1.94-1.44,3.22-1.44s2.27.41,2.98,1.24c.7.83,1.05,1.98,1.05,3.45v.82Zm-1.61-1.33c0-.91-.23-1.61-.66-2.11-.43-.5-1.02-.76-1.79-.76s-1.37.26-1.89.79-.84,1.22-.96,2.08h5.29Zm8.53,5.74c-.37.2-.86.31-1.46.31-1.72,0-2.57-.96-2.57-2.87v-5.8h-1.68v-1.34h1.68v-2.39l1.57-.51v2.9h2.47v1.34h-2.47v5.52c0,.66.11,1.13.33,1.41s.59.42,1.11.42c.4,0,.74-.11,1.02-.33v1.34Z" />
				<path d="m564.22,770.33h-10v-18.87h9.58v2h-7.37v6.28h6.82v1.99h-6.82v6.61h7.79v2Zm14.55,0h-2.16v-7.69c0-2.86-1.04-4.29-3.13-4.29-1.08,0-1.97.41-2.68,1.22-.7.81-1.05,1.83-1.05,3.07v7.69h-2.16v-13.48h2.16v2.24h.05c1.02-1.7,2.49-2.55,4.42-2.55,1.47,0,2.6.48,3.38,1.43.78.95,1.17,2.32,1.17,4.12v8.24Zm10.34-.13c-.51.28-1.18.42-2.01.42-2.36,0-3.54-1.32-3.54-3.95v-7.98h-2.32v-1.84h2.32v-3.29l2.16-.7v3.99h3.4v1.84h-3.4v7.59c0,.9.15,1.55.46,1.93s.82.58,1.53.58c.54,0,1.01-.15,1.41-.45v1.84Zm9.93-11.16c-.38-.29-.92-.43-1.63-.43-.92,0-1.69.43-2.32,1.3-.61.87-.92,2.05-.92,3.55v6.87h-2.16v-13.48h2.16v2.78h.05c.31-.95.78-1.68,1.41-2.21.63-.54,1.34-.8,2.12-.8.56,0,.99.06,1.29.18v2.24Zm13.1-2.18l-6.2,15.64c-1.11,2.79-2.66,4.19-4.66,4.19-.56,0-1.03-.06-1.41-.17v-1.93c.47.16.89.24,1.28.24,1.09,0,1.9-.65,2.45-1.95l1.08-2.55-5.26-13.45h2.4l3.65,10.37c.04.13.14.47.28,1.03h.08c.04-.21.13-.54.26-1l3.83-10.4h2.24Z" />
				<path d="m180.56,322.43v-18.87h5.37c1.63,0,2.93.4,3.88,1.2.96.8,1.43,1.84,1.43,3.12,0,1.07-.29,2-.87,2.79-.58.79-1.38,1.35-2.4,1.68v.05c1.27.15,2.29.63,3.05,1.45.76.81,1.15,1.86,1.15,3.16,0,1.61-.58,2.92-1.74,3.92-1.16,1-2.62,1.5-4.38,1.5h-5.5Zm2.21-16.87v6.09h2.26c1.21,0,2.16-.29,2.86-.87.69-.59,1.04-1.41,1.04-2.47,0-1.83-1.21-2.75-3.62-2.75h-2.54Zm0,8.08v6.79h3c1.3,0,2.3-.31,3.01-.92.72-.61,1.08-1.46,1.08-2.53,0-2.23-1.52-3.34-4.55-3.34h-2.54Zm23.75,2.59h-9.52c.04,1.5.44,2.66,1.21,3.47.77.82,1.83,1.22,3.18,1.22,1.52,0,2.91-.5,4.19-1.5v2.03c-1.18.86-2.75,1.29-4.7,1.29s-3.4-.61-4.49-1.83c-1.09-1.23-1.63-2.95-1.63-5.17,0-2.1.59-3.8,1.78-5.12,1.19-1.32,2.67-1.99,4.44-1.99s3.13.57,4.09,1.71,1.45,2.72,1.45,4.75v1.13Zm-2.21-1.83c0-1.25-.31-2.22-.91-2.91-.59-.69-1.41-1.04-2.46-1.04s-1.88.36-2.59,1.09c-.71.73-1.15,1.68-1.32,2.86h7.28Zm16.95,8.03h-2.16v-2.29h-.05c-1,1.74-2.54,2.61-4.63,2.61-1.69,0-3.05-.6-4.07-1.8-1.01-1.21-1.51-2.86-1.51-4.94,0-2.23.56-4.01,1.68-5.36,1.12-1.34,2.62-2.01,4.49-2.01s3.2.73,4.04,2.18h.05v-8.34h2.16v19.95Zm-2.16-6.09v-1.99c0-1.09-.36-2.01-1.08-2.76-.72-.75-1.63-1.13-2.74-1.13-1.32,0-2.35.48-3.11,1.45-.75.97-1.13,2.3-1.13,4,0,1.55.36,2.78,1.08,3.69.73.89,1.7,1.34,2.92,1.34s2.18-.43,2.92-1.3c.75-.87,1.13-1.97,1.13-3.29Zm13.54-5.2c-.38-.29-.92-.43-1.63-.43-.92,0-1.69.43-2.32,1.3-.61.87-.92,2.05-.92,3.55v6.87h-2.16v-13.48h2.16v2.78h.05c.31-.95.78-1.68,1.41-2.21.63-.54,1.34-.8,2.12-.8.56,0,.99.06,1.29.18v2.24Zm7.96,11.61c-1.99,0-3.58-.63-4.78-1.88-1.18-1.26-1.78-2.93-1.78-5.01,0-2.26.62-4.03,1.86-5.3,1.24-1.27,2.91-1.91,5.01-1.91s3.58.62,4.7,1.86c1.13,1.24,1.7,2.95,1.7,5.15s-.61,3.87-1.83,5.17c-1.21,1.29-2.84,1.93-4.88,1.93Zm.16-12.29c-1.39,0-2.48.47-3.29,1.42-.81.94-1.21,2.24-1.21,3.9s.41,2.86,1.22,3.78c.82.92,1.91,1.38,3.28,1.38s2.47-.45,3.21-1.36c.75-.9,1.13-2.19,1.13-3.86s-.38-2.98-1.13-3.9c-.75-.91-1.82-1.37-3.21-1.37Zm15.61,12.29c-1.99,0-3.58-.63-4.78-1.88-1.18-1.26-1.78-2.93-1.78-5.01,0-2.26.62-4.03,1.86-5.3,1.24-1.27,2.91-1.91,5.01-1.91s3.58.62,4.7,1.86c1.13,1.24,1.7,2.95,1.7,5.15s-.61,3.87-1.83,5.17c-1.21,1.29-2.84,1.93-4.88,1.93Zm.16-12.29c-1.39,0-2.48.47-3.29,1.42-.81.94-1.21,2.24-1.21,3.9s.41,2.86,1.22,3.78c.82.92,1.91,1.38,3.28,1.38s2.47-.45,3.21-1.36c.75-.9,1.13-2.19,1.13-3.86s-.38-2.98-1.13-3.9c-.75-.91-1.82-1.37-3.21-1.37Zm29.12,11.98h-2.16v-7.74c0-1.49-.23-2.57-.7-3.24-.46-.67-1.23-1-2.32-1-.92,0-1.71.42-2.36,1.26-.64.84-.96,1.85-.96,3.03v7.69h-2.16v-8c0-2.65-1.02-3.97-3.07-3.97-.95,0-1.73.4-2.34,1.2-.61.79-.92,1.82-.92,3.09v7.69h-2.16v-13.48h2.16v2.13h.05c.96-1.63,2.35-2.45,4.19-2.45.92,0,1.72.26,2.41.78.68.51,1.15,1.18,1.41,2.01,1-1.86,2.49-2.79,4.47-2.79,2.97,0,4.45,1.83,4.45,5.49v8.3Z" />
				<path d="m185.96,350.41h-1.57v-11.86c-.12.12-.3.26-.54.42-.23.15-.49.31-.78.46-.29.15-.59.3-.92.43-.32.13-.63.24-.94.32v-1.59c.34-.1.71-.22,1.09-.38.39-.17.77-.35,1.14-.55.38-.2.73-.41,1.06-.63.33-.22.62-.44.86-.65h.59v14.03Zm13.42-6.92c0,1.15-.11,2.17-.32,3.05-.2.89-.5,1.64-.9,2.25-.39.61-.87,1.07-1.44,1.39-.57.31-1.22.47-1.94.47-.69,0-1.3-.15-1.85-.45-.54-.31-.99-.75-1.36-1.33-.37-.58-.65-1.29-.84-2.13-.19-.85-.29-1.82-.29-2.91,0-1.2.1-2.26.3-3.18.2-.92.5-1.69.89-2.31.39-.63.87-1.09,1.44-1.41.58-.32,1.24-.48,1.99-.48,2.88,0,4.32,2.34,4.32,7.03Zm-1.61.15c0-3.9-.93-5.86-2.78-5.86-1.96,0-2.94,1.99-2.94,5.96,0,3.71.96,5.56,2.88,5.56s2.84-1.89,2.84-5.66Z" />
				<rect x="201.76" y="336.69" width="1.39" height="4.28" />
				<path d="m213.91,346.22c0,.67-.11,1.28-.34,1.82s-.56,1.01-.99,1.4c-.42.39-.93.69-1.53.9-.6.21-1.27.32-2,.32-1.28,0-2.22-.19-2.84-.57v-1.66c.93.6,1.89.9,2.86.9.5,0,.94-.07,1.34-.22.4-.15.74-.35,1.02-.61.28-.26.49-.58.64-.95.15-.37.23-.78.23-1.22,0-.89-.3-1.59-.9-2.1-.6-.51-1.47-.77-2.61-.77-.18,0-.38,0-.58,0-.2,0-.41.02-.61.03-.2,0-.41.02-.6.03-.19.01-.37.03-.53.05l.47-6.88h6.34v1.42h-4.99l-.28,4.03c.2-.01.42-.02.65-.03.23-.01.43-.02.61-.02.73,0,1.38.1,1.95.29.57.19,1.06.47,1.45.82.4.35.7.78.91,1.3.21.51.32,1.08.32,1.72Z" />
				<path d="m218.17,336.69v4.28h-1.39v-4.28h1.39Zm3.18,0v4.28h-1.39v-4.28h1.39Z" />
				<path d="m237.04,340.61l-3.29,4.96,3.23,4.84h-1.83l-1.92-3.18c-.12-.2-.26-.45-.43-.75h-.04c-.03.06-.18.31-.45.75l-1.96,3.18h-1.81l3.34-4.8-3.2-4.99h1.83l1.89,3.35c.14.25.28.5.41.77h.04l2.45-4.11h1.73Z" />
				<path d="m249.59,350.41h-1.57v-11.86c-.12.12-.3.26-.54.42-.23.15-.49.31-.78.46-.29.15-.59.3-.92.43-.32.13-.63.24-.94.32v-1.59c.34-.1.71-.22,1.09-.38.39-.17.77-.35,1.14-.55.38-.2.73-.41,1.06-.63.33-.22.62-.44.86-.65h.59v14.03Zm10.58,0h-1.57v-11.86c-.12.12-.3.26-.54.42-.23.15-.49.31-.78.46-.29.15-.59.3-.92.43-.32.13-.63.24-.94.32v-1.59c.34-.1.71-.22,1.09-.38.39-.17.77-.35,1.14-.55.38-.2.73-.41,1.06-.63.33-.22.62-.44.86-.65h.59v14.03Z" />
				<rect x="265.4" y="336.69" width="1.39" height="4.28" />
				<path d="m276.41,336.69v9.06h1.76v1.44h-1.76v3.22h-1.55v-3.22h-6.45v-1.36c.6-.68,1.21-1.4,1.82-2.16.61-.77,1.2-1.55,1.75-2.34.56-.79,1.08-1.58,1.55-2.36.48-.79.88-1.55,1.21-2.27h1.67Zm-6.23,9.06h4.68v-6.72c-.48.84-.93,1.58-1.36,2.24-.43.66-.84,1.25-1.22,1.79-.38.54-.75,1.02-1.1,1.45-.35.43-.68.85-1,1.23Z" />
				<path d="m281.81,336.69v4.28h-1.39v-4.28h1.39Zm3.18,0v4.28h-1.39v-4.28h1.39Z" />
				<path d="m720.83,387.46h-3.08l-7.29-8.63c-.27-.32-.44-.54-.5-.66h-.05v9.29h-2.21v-18.87h2.21v8.87h.05c.12-.19.29-.41.5-.64l7.05-8.23h2.75l-8.09,9.05,8.66,9.82Zm3.3-16.9c-.39,0-.72-.13-.99-.39-.27-.26-.41-.6-.41-1s.14-.74.41-1c.27-.27.6-.41.99-.41s.73.14,1,.41c.28.26.42.6.42,1s-.14.72-.42.99c-.27.27-.61.41-1,.41Zm1.05,16.9h-2.16v-13.48h2.16v13.48Zm10.6-.13c-.51.28-1.18.42-2.01.42-2.36,0-3.54-1.32-3.54-3.95v-7.98h-2.32v-1.84h2.32v-3.29l2.16-.7v3.99h3.4v1.84h-3.4v7.59c0,.9.15,1.55.46,1.93.31.39.82.58,1.53.58.54,0,1.01-.15,1.41-.45v1.84Zm12.05-.49c-1.04.62-2.26.93-3.69.93-1.92,0-3.47-.62-4.66-1.87-1.18-1.25-1.76-2.88-1.76-4.87,0-2.22.64-4,1.91-5.34,1.27-1.35,2.97-2.03,5.09-2.03,1.18,0,2.23.22,3.13.66v2.21c-1-.7-2.07-1.05-3.21-1.05-1.38,0-2.51.5-3.4,1.49-.88.98-1.32,2.28-1.32,3.88s.41,2.83,1.24,3.74c.83.91,1.95,1.37,3.34,1.37,1.18,0,2.28-.39,3.32-1.17v2.05Zm14.43.62h-2.16v-7.76c0-2.81-1.04-4.21-3.13-4.21-1.05,0-1.94.41-2.66,1.22-.72.81-1.08,1.85-1.08,3.12v7.63h-2.16v-19.95h2.16v8.71h.05c1.04-1.7,2.51-2.55,4.42-2.55,3.04,0,4.55,1.83,4.55,5.49v8.3Zm14.88-6.2h-9.52c.04,1.5.44,2.66,1.21,3.47.77.82,1.83,1.22,3.18,1.22,1.52,0,2.91-.5,4.19-1.5v2.03c-1.18.86-2.75,1.29-4.7,1.29s-3.4-.61-4.49-1.83c-1.09-1.23-1.63-2.95-1.63-5.17,0-2.1.59-3.8,1.78-5.12,1.19-1.32,2.67-1.99,4.44-1.99s3.13.57,4.09,1.71c.97,1.14,1.45,2.72,1.45,4.75v1.13Zm-2.21-1.83c0-1.25-.31-2.22-.91-2.91-.59-.69-1.41-1.04-2.46-1.04s-1.88.36-2.59,1.09c-.71.73-1.15,1.68-1.32,2.86h7.28Zm16.64,8.03h-2.16v-7.69c0-2.86-1.04-4.29-3.13-4.29-1.08,0-1.97.41-2.68,1.22-.7.81-1.05,1.83-1.05,3.07v7.69h-2.16v-13.48h2.16v2.24h.05c1.02-1.7,2.49-2.55,4.42-2.55,1.47,0,2.6.48,3.38,1.43.78.95,1.17,2.32,1.17,4.12v8.24Z" />
				<path d="m427.86,336.15h-9.79v-18.87h2.21v16.87h7.58v2Zm3.71-16.9c-.39,0-.72-.13-.99-.39-.27-.26-.41-.6-.41-1s.14-.74.41-1c.27-.27.6-.41.99-.41s.73.14,1,.41c.28.26.42.6.42,1s-.14.72-.42.99c-.27.27-.61.41-1,.41Zm1.05,16.9h-2.16v-13.48h2.16v13.48Zm14.95-13.48l-5.37,13.48h-2.12l-5.11-13.48h2.37l3.42,9.79c.25.72.41,1.35.47,1.88h.05c.09-.68.23-1.29.42-1.83l3.58-9.84h2.28Zm3.41-3.42c-.39,0-.72-.13-.99-.39-.27-.26-.41-.6-.41-1s.14-.74.41-1c.27-.27.6-.41.99-.41s.73.14,1,.41c.28.26.42.6.42,1s-.14.72-.42.99c-.27.27-.61.41-1,.41Zm1.05,16.9h-2.16v-13.48h2.16v13.48Zm15.54,0h-2.16v-7.69c0-2.86-1.04-4.29-3.13-4.29-1.08,0-1.97.41-2.68,1.22-.7.81-1.05,1.83-1.05,3.07v7.69h-2.16v-13.48h2.16v2.24h.05c1.02-1.7,2.49-2.55,4.42-2.55,1.47,0,2.6.48,3.38,1.43.78.95,1.17,2.32,1.17,4.12v8.24Zm15.56-1.08c0,4.95-2.37,7.42-7.11,7.42-1.67,0-3.12-.32-4.37-.95v-2.16c1.52.84,2.97,1.26,4.34,1.26,3.32,0,4.97-1.76,4.97-5.29v-1.47h-.05c-1.03,1.72-2.57,2.58-4.63,2.58-1.68,0-3.03-.6-4.05-1.79-1.02-1.2-1.53-2.81-1.53-4.83,0-2.29.55-4.11,1.65-5.46,1.11-1.35,2.61-2.03,4.53-2.03s3.16.73,4.04,2.18h.05v-1.87h2.16v12.4Zm-2.16-5.01v-1.99c0-1.07-.36-1.99-1.09-2.75-.72-.76-1.62-1.15-2.7-1.15-1.33,0-2.38.49-3.13,1.46-.75.97-1.13,2.32-1.13,4.07,0,1.5.36,2.7,1.08,3.61.73.89,1.69,1.34,2.88,1.34s2.19-.43,2.95-1.29c.76-.86,1.15-1.96,1.15-3.3Z" />
				<polygon points="496.01 317.28 486.95 339.28 484.94 339.28 493.97 317.28 496.01 317.28" />
				<path d="m498.2,336.15v-18.87h5.21c6.65,0,9.98,3.07,9.98,9.2,0,2.91-.93,5.26-2.78,7.03-1.84,1.76-4.31,2.65-7.41,2.65h-5Zm2.21-16.87v14.87h2.82c2.47,0,4.4-.66,5.78-1.99,1.38-1.32,2.07-3.2,2.07-5.63,0-4.83-2.57-7.25-7.71-7.25h-2.95Zm17.42-.03c-.39,0-.72-.13-.99-.39s-.41-.6-.41-1,.14-.74.41-1c.27-.27.6-.41.99-.41s.73.14,1,.41c.28.26.42.6.42,1s-.14.72-.42.99c-.27.27-.61.41-1,.41Zm1.05,16.9h-2.16v-13.48h2.16v13.48Zm15.47,0h-2.16v-7.69c0-2.86-1.04-4.29-3.13-4.29-1.08,0-1.97.41-2.68,1.22-.7.81-1.05,1.83-1.05,3.07v7.69h-2.16v-13.48h2.16v2.24h.05c1.02-1.7,2.49-2.55,4.42-2.55,1.47,0,2.6.48,3.38,1.43.78.95,1.17,2.32,1.17,4.12v8.24Zm5.09-16.9c-.39,0-.72-.13-.99-.39s-.41-.6-.41-1,.14-.74.41-1c.27-.27.6-.41.99-.41s.73.14,1,.41c.28.26.42.6.42,1s-.14.72-.42.99c-.27.27-.61.41-1,.41Zm1.05,16.9h-2.16v-13.48h2.16v13.48Zm15.47,0h-2.16v-7.69c0-2.86-1.04-4.29-3.13-4.29-1.08,0-1.97.41-2.68,1.22-.7.81-1.05,1.83-1.05,3.07v7.69h-2.16v-13.48h2.16v2.24h.05c1.02-1.7,2.49-2.55,4.42-2.55,1.47,0,2.6.48,3.38,1.43.78.95,1.17,2.32,1.17,4.12v8.24Zm15.49-1.08c0,4.95-2.37,7.42-7.11,7.42-1.67,0-3.12-.32-4.37-.95v-2.16c1.52.84,2.97,1.26,4.34,1.26,3.32,0,4.97-1.76,4.97-5.29v-1.47h-.05c-1.03,1.72-2.57,2.58-4.63,2.58-1.68,0-3.03-.6-4.05-1.79-1.02-1.2-1.53-2.81-1.53-4.83,0-2.29.55-4.11,1.65-5.46,1.11-1.35,2.61-2.03,4.53-2.03s3.16.73,4.04,2.18h.05v-1.87h2.16v12.4Zm-2.16-5.01v-1.99c0-1.07-.36-1.99-1.09-2.75-.72-.76-1.62-1.14-2.7-1.14-1.33,0-2.38.49-3.13,1.46-.75.97-1.13,2.32-1.13,4.07,0,1.5.36,2.7,1.08,3.61.73.9,1.69,1.34,2.88,1.34s2.19-.43,2.95-1.29c.76-.86,1.15-1.96,1.15-3.3Z" />
				<path d="m597.26,336.15h-2.63l-3.16-5.29c-.29-.49-.57-.91-.84-1.25-.27-.35-.55-.64-.84-.86-.28-.22-.59-.38-.92-.47-.32-.11-.69-.16-1.11-.16h-1.82v8.03h-2.21v-18.87h5.63c.82,0,1.58.11,2.28.32.7.2,1.31.51,1.82.93.52.42.92.95,1.21,1.58.29.62.43,1.36.43,2.2,0,.66-.1,1.26-.3,1.82-.19.54-.47,1.03-.84,1.46-.36.43-.8.8-1.32,1.11-.51.3-1.08.53-1.72.7v.05c.32.14.59.3.82.49.24.18.46.39.67.63.21.25.42.53.62.84.21.31.44.67.7,1.08l3.54,5.67Zm-11.32-16.87v6.84h3c.55,0,1.06-.08,1.53-.25.47-.17.88-.4,1.22-.71.34-.32.61-.7.8-1.15.19-.46.29-.97.29-1.53,0-1.01-.33-1.79-.99-2.36-.65-.57-1.59-.86-2.83-.86h-3.03Zm19.17,17.19c-1.99,0-3.58-.63-4.78-1.88-1.18-1.26-1.78-2.93-1.78-5.01,0-2.26.62-4.03,1.86-5.3s2.91-1.91,5.01-1.91,3.58.62,4.7,1.86c1.13,1.24,1.7,2.95,1.7,5.15s-.61,3.87-1.83,5.17c-1.21,1.29-2.84,1.93-4.88,1.93Zm.16-12.29c-1.39,0-2.48.47-3.29,1.42-.81.94-1.21,2.24-1.21,3.9s.41,2.86,1.22,3.78c.82.92,1.91,1.38,3.28,1.38s2.47-.45,3.21-1.36c.75-.9,1.13-2.19,1.13-3.86s-.38-2.98-1.13-3.9c-.75-.91-1.82-1.37-3.21-1.37Zm15.55,12.29c-1.99,0-3.58-.63-4.78-1.88-1.18-1.26-1.78-2.93-1.78-5.01,0-2.26.62-4.03,1.86-5.3,1.24-1.27,2.91-1.91,5.01-1.91s3.58.62,4.7,1.86c1.13,1.24,1.7,2.95,1.7,5.15s-.61,3.87-1.83,5.17c-1.21,1.29-2.84,1.93-4.88,1.93Zm.16-12.29c-1.39,0-2.48.47-3.29,1.42-.81.94-1.21,2.24-1.21,3.9s.41,2.86,1.22,3.78c.82.92,1.91,1.38,3.28,1.38s2.47-.45,3.21-1.36c.75-.9,1.13-2.19,1.13-3.86s-.38-2.98-1.13-3.9c-.75-.91-1.82-1.37-3.21-1.37Zm29.06,11.98h-2.16v-7.74c0-1.49-.23-2.57-.7-3.24-.46-.67-1.23-1-2.32-1-.92,0-1.71.42-2.36,1.26-.64.84-.96,1.85-.96,3.03v7.69h-2.16v-8c0-2.65-1.02-3.97-3.07-3.97-.95,0-1.73.4-2.34,1.2-.61.79-.92,1.82-.92,3.09v7.69h-2.16v-13.48h2.16v2.13h.05c.96-1.63,2.35-2.45,4.19-2.45.92,0,1.72.26,2.41.78.68.51,1.15,1.18,1.41,2.01,1-1.86,2.49-2.79,4.47-2.79,2.97,0,4.45,1.83,4.45,5.49v8.3Z" />
				<path d="m485.93,360.3c0-.36.06-.73.17-1.09.11-.37.28-.71.49-1.03.22-.32.48-.61.79-.87.32-.26.68-.47,1.08-.62-.59-.33-1.07-.76-1.42-1.27-.35-.52-.53-1.1-.53-1.73,0-.5.1-.97.29-1.4.2-.43.47-.8.81-1.11s.75-.56,1.22-.73c.47-.18.98-.27,1.53-.27s1.07.09,1.54.27c.47.18.88.42,1.22.74s.61.68.8,1.11c.19.43.29.89.29,1.39,0,.63-.18,1.21-.53,1.73-.35.52-.82.94-1.4,1.27.4.15.75.36,1.06.62.31.26.57.55.78.87.22.32.38.66.5,1.03.11.36.17.73.17,1.09,0,.6-.11,1.15-.33,1.65-.22.5-.52.92-.92,1.28-.39.35-.86.63-1.41.82-.54.2-1.14.3-1.8.3s-1.25-.1-1.79-.3c-.54-.2-1.01-.47-1.41-.82-.4-.36-.7-.78-.93-1.28-.22-.5-.33-1.05-.33-1.65Zm1.7-.13c0,.43.06.81.19,1.16.13.34.32.64.55.88.24.24.53.43.87.56.34.13.72.19,1.14.19s.77-.07,1.11-.2c.34-.13.63-.32.87-.56.25-.24.44-.54.57-.88.14-.34.21-.73.21-1.15,0-.38-.07-.74-.2-1.07-.13-.34-.31-.63-.55-.89-.24-.26-.53-.46-.87-.6-.34-.15-.72-.22-1.14-.22-.4,0-.76.07-1.1.21-.33.13-.62.33-.87.57-.24.24-.43.54-.57.88-.14.34-.21.71-.21,1.12Zm.49-6.36c0,.33.06.63.17.91.12.27.28.52.49.73.21.2.45.37.73.49.27.11.57.17.88.17s.61-.06.88-.18c.28-.12.52-.28.73-.49.2-.21.37-.45.49-.73.12-.28.18-.58.18-.9s-.06-.64-.18-.92c-.11-.28-.27-.52-.48-.73-.2-.2-.45-.36-.73-.48-.27-.12-.57-.18-.89-.18-.34,0-.65.06-.93.18-.27.12-.51.29-.72.5-.2.2-.35.45-.46.73-.11.28-.16.58-.16.9Z" />
				<rect x="497.22" y="350.4" width="1.39" height="4.28" />
				<path d="m509.86,357.21c0,1.15-.11,2.17-.32,3.05-.2.89-.5,1.64-.9,2.25-.39.61-.87,1.07-1.44,1.39-.57.31-1.22.47-1.94.47-.69,0-1.3-.15-1.85-.45-.54-.31-.99-.75-1.36-1.33-.37-.58-.65-1.29-.84-2.13-.19-.85-.29-1.82-.29-2.91,0-1.2.1-2.26.3-3.18.2-.92.5-1.69.89-2.31.39-.63.87-1.09,1.44-1.41.58-.32,1.24-.48,1.99-.48,2.88,0,4.32,2.34,4.32,7.03Zm-1.61.15c0-3.9-.93-5.86-2.78-5.86-1.96,0-2.94,1.99-2.94,5.96,0,3.71.96,5.56,2.88,5.56s2.84-1.89,2.84-5.66Z" />
				<path d="m513.63,350.4v4.28h-1.39v-4.28h1.39Zm3.18,0v4.28h-1.39v-4.28h1.39Z" />
				<path d="m532.5,354.33l-3.29,4.96,3.23,4.84h-1.83l-1.92-3.18c-.12-.2-.26-.45-.43-.75h-.04c-.03.06-.18.31-.45.75l-1.96,3.18h-1.81l3.34-4.8-3.2-4.99h1.83l1.89,3.35c.14.25.28.5.41.77h.04l2.45-4.11h1.73Z" />
				<path d="m545.05,364.12h-1.57v-11.86c-.12.12-.3.26-.54.42-.23.15-.49.31-.78.46-.29.15-.59.3-.92.43-.32.13-.63.24-.94.32v-1.59c.34-.1.71-.22,1.09-.38.39-.17.77-.35,1.14-.55.38-.2.73-.41,1.06-.63.33-.22.62-.44.86-.65h.59v14.03Zm11.04-10.12c0-.42-.07-.79-.2-1.1-.13-.31-.31-.57-.54-.78-.22-.21-.49-.37-.79-.47-.31-.1-.64-.15-1-.15-.31,0-.61.04-.9.12s-.58.2-.86.34c-.27.15-.54.32-.8.53-.26.2-.49.43-.72.68v-1.68c.44-.43.93-.75,1.47-.98.55-.23,1.22-.34,2-.34.56,0,1.08.08,1.56.25.48.16.89.4,1.24.71.35.31.63.7.82,1.16.2.46.31.99.31,1.58,0,.54-.06,1.03-.19,1.47-.12.44-.31.85-.56,1.24-.25.39-.56.76-.95,1.12-.38.36-.83.72-1.35,1.09-.64.46-1.18.85-1.6,1.18-.41.33-.75.63-1,.92-.24.28-.41.56-.52.85-.1.28-.14.61-.14.98h6.83v1.41h-8.47v-.68c0-.59.06-1.1.19-1.55.13-.45.34-.87.63-1.27.29-.4.68-.8,1.15-1.21.48-.4,1.06-.85,1.75-1.36.5-.36.91-.7,1.24-1.02.34-.33.61-.65.81-.98.2-.33.35-.65.43-.99.09-.34.13-.7.13-1.07Z" />
				<rect x="560.85" y="350.4" width="1.39" height="4.28" />
				<path d="m573.4,351.31c-.21.36-.47.82-.77,1.36-.29.54-.61,1.15-.94,1.83-.33.68-.67,1.4-1.01,2.18s-.67,1.58-.97,2.41c-.3.83-.56,1.67-.79,2.53-.22.85-.39,1.68-.49,2.51h-1.68c.11-.82.29-1.65.53-2.5.24-.85.51-1.69.81-2.51.31-.82.63-1.61.97-2.37.34-.76.67-1.46.99-2.1.32-.64.61-1.2.87-1.68.27-.49.48-.87.64-1.15h-6.88v-1.42h8.73v.91Z" />
				<path d="m577.27,350.4v4.28h-1.39v-4.28h1.39Zm3.18,0v4.28h-1.39v-4.28h1.39Z" />
				<path d="m407.34,804.43l-3.1,10.99h-1.51l-2.26-8.03c-.1-.34-.16-.72-.18-1.12h-.03c-.03.38-.1.75-.2,1.1l-2.28,8.05h-1.49l-3.22-10.99h1.42l2.34,8.43c.1.35.16.72.18,1.1h.04c.03-.27.1-.64.24-1.1l2.43-8.43h1.23l2.33,8.49c.08.29.14.63.18,1.03h.03c.02-.27.09-.62.21-1.06l2.25-8.46h1.4Z" />
				<polygon points="413.75 804.43 408.48 817.25 407.3 817.25 412.56 804.43 413.75 804.43" />
				<path d="m415.03,815.42v-10.99h3.04c3.87,0,5.81,1.79,5.81,5.36,0,1.7-.54,3.06-1.62,4.09-1.07,1.03-2.51,1.54-4.32,1.54h-2.91Zm1.29-9.83v8.66h1.64c1.44,0,2.56-.39,3.37-1.16.8-.77,1.2-1.87,1.2-3.28,0-2.82-1.5-4.22-4.49-4.22h-1.72Z" />
			</g>
		</g>
	)
}

export default PlanCC
